webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topHeader__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_topHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_swipe__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shareContent__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shareContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shareContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_aboutContent__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_aboutContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_aboutContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_downloadContent__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_downloadContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_downloadContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_jobContent__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_jobContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_jobContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_homePage0__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_homePage0___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_homePage0__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_homePage1__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_homePage1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_homePage1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_homePage2__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_homePage2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_homePage2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_aps__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_aps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_aps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ac1__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ac1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ac1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ac2__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ac2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_ac2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ac3__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ac3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_ac3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_open__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_open___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_open__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_login__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_backend__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_main_index__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_main_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_main_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_main_printer__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_main_printer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_main_printer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_main_log__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_main_log___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_main_log__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_main_printTest__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_main_printTest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_main_printTest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_main_printRecord__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_main_printRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_main_printRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_main_sim__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_main_sim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_main_sim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_main_deposit__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_main_deposit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_main_deposit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_main_callback__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_main_callback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_main_callback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_main_center__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_main_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_main_center__);





























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            swipe: __WEBPACK_IMPORTED_MODULE_3__components_swipe___default.a,
            homePage0: __WEBPACK_IMPORTED_MODULE_9__components_homePage0___default.a,
            homePage1: __WEBPACK_IMPORTED_MODULE_10__components_homePage1___default.a,
            homePage2: __WEBPACK_IMPORTED_MODULE_11__components_homePage2___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a
        },
        beforeEnter: function beforeEnter(to, from, next) {
            [].forEach.call(document.getElementsByTagName('li'), function (item) {
                item.className = '';
            });
            next();
        }
    }, {
        path: '/aps',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            aps: __WEBPACK_IMPORTED_MODULE_12__components_aps___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a
        }
    }, {
        path: '/brief',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a,
            aboutContent: __WEBPACK_IMPORTED_MODULE_6__components_aboutContent___default.a
        }
    }, {
        path: '/ac1',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a,
            ac1: __WEBPACK_IMPORTED_MODULE_13__components_ac1___default.a
        }
    }, {
        path: '/ac2',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a,
            ac2: __WEBPACK_IMPORTED_MODULE_14__components_ac2___default.a
        }
    }, {
        path: '/ac3',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a,
            ac3: __WEBPACK_IMPORTED_MODULE_15__components_ac3___default.a
        }
    }, {
        path: '/open',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            open: __WEBPACK_IMPORTED_MODULE_16__components_open___default.a
        }
    }, {
        path: '/cooperation',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            shareContent: __WEBPACK_IMPORTED_MODULE_5__components_shareContent___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a
        }
    }, {
        path: '/job',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a,
            jobContent: __WEBPACK_IMPORTED_MODULE_8__components_jobContent___default.a
        }
    }, {
        path: '/contact',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a,
            downloadContent: __WEBPACK_IMPORTED_MODULE_7__components_downloadContent___default.a
        }
    }, {
        path: '/login',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            footer: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a,
            login: __WEBPACK_IMPORTED_MODULE_17__components_login___default.a
        }
    }, {
        path: '/backend',
        components: {
            topHeader: __WEBPACK_IMPORTED_MODULE_2__components_topHeader___default.a,
            backend: __WEBPACK_IMPORTED_MODULE_18__components_backend___default.a
        },
        children: [{
            path: "index",
            component: __WEBPACK_IMPORTED_MODULE_19__components_main_index___default.a
        }, {
            path: "center",
            component: __WEBPACK_IMPORTED_MODULE_27__components_main_center___default.a
        }, {
            path: "printer",
            component: __WEBPACK_IMPORTED_MODULE_20__components_main_printer___default.a
        }, {
            path: "log",
            component: __WEBPACK_IMPORTED_MODULE_21__components_main_log___default.a
        }, {
            path: "printTest",
            component: __WEBPACK_IMPORTED_MODULE_22__components_main_printTest___default.a
        }, {
            path: "printRecord",
            component: __WEBPACK_IMPORTED_MODULE_23__components_main_printRecord___default.a
        }, {
            path: "sim",
            component: __WEBPACK_IMPORTED_MODULE_24__components_main_sim___default.a
        }, {
            path: "deposit",
            component: __WEBPACK_IMPORTED_MODULE_25__components_main_deposit___default.a
        }, {
            path: "callback",
            component: __WEBPACK_IMPORTED_MODULE_26__components_main_callback___default.a
        }]
    }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },

    mode: 'history'
}));

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */,
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(261)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(326),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(168);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	methods: {
		clickEvent: function clickEvent(path) {
			this.$router.push(path);
		}
	}
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            developer: null,
            menus: [{
                icon: "icon-shouye",
                label: "首 页",
                path: "/backend/index",
                active: true
            }, {
                icon: "icon-dayinji",
                label: "设备管理",
                path: "/backend/printer",
                active: false
            }, {
                icon: "icon-ceshi",
                label: "打印测试",
                path: "/backend/printTest",
                active: false
            }, {
                icon: "icon-jilu",
                label: "打印记录",
                path: "/backend/printRecord",
                active: false
            }, {
                icon: "icon-sim",
                label: "机载物联卡",
                path: "/backend/sim",
                active: false
            }, {
                icon: "icon-deposit",
                label: "充值记录",
                path: "/backend/deposit",
                active: false
            }, {
                icon: "icon-huidiao",
                label: "回调地址设置",
                path: "/backend/callback",
                active: false
            }, {
                icon: "icon-desktop",
                label: "登录日志",
                path: "/backend/log",
                active: false
            }, {
                icon: "icon-yonghu",
                label: "个人中心",
                path: "/backend/center",
                active: false
            }],
            breadcrumb: ""
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        if (!loginInfoStr) {
            this.$router.push("/login");
        } else {
            this.developer = JSON.parse(loginInfoStr).developer;
        }
        if (this.$route.path != "/backend/index") {
            for (var i = 0; i < this.menus.length; i++) {
                if (this.$route.path == this.menus[i].path) {
                    this.setMenuActive(this.menus[i]);
                    break;
                }
            }
        }
    },

    methods: {
        jump: function jump(path) {
            var _this = this;

            this.$parent.$refs.header.jump(path);
            setTimeout(function () {
                _this.$parent.$refs.openapi.showCallback();
            }, 200);
        },
        clickMenu: function clickMenu(menuIndex) {
            this.menuClick(this.menus[menuIndex]);
        },
        logout: function logout() {
            sessionStorage.removeItem("loginInfo");
            this.$router.push("/login");
        },
        setMenuActive: function setMenuActive(menu) {
            for (var i = 0; i < this.menus.length; i++) {
                if (this.menus[i].active) {
                    this.menus[i].active = false;
                    break;
                }
            }
            menu.active = true;
            if (menu.label != "首 页") {
                this.breadcrumb = menu.label;
            } else {
                this.breadcrumb = "";
            }
        },
        menuClick: function menuClick(item) {
            if (!item.active) {
                this.setMenuActive(item);

                this.$router.push(item.path);
            }
        },
        changeHeader: function changeHeader(header) {
            this.developer.header = header;
        },
        changeName: function changeName(name) {
            this.developer.name = name;
        }
    }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function ($) {

			'use strict';

			var $body_html = $('body, html'),
			    $html = $('html'),
			    $body = $('body'),
			    $scroll_to_top = $('#scroll-to-top'),
			    $preloader = $('#preloader'),
			    $loader = $preloader.find('.loader');

			var ua_test = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
			    is_mobile = ua_test.test(navigator.userAgent);
			$html.addClass(is_mobile ? 'mobile' : 'no-mobile');

			$(window).load(function () {

				$loader.delay(1500).fadeOut();
				$preloader.delay(500).fadeOut('slow');

				$body.addClass('loaded');
			});
		});

		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scroll(function () {
				var top = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").offset().top;
				var scrollTop = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
				if (scrollTop > top) {
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".header").addClass("active");
				} else {
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".header").removeClass("active");
				}
			});
		});

		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".imgli").click(function () {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".imgli").removeClass("cur");
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("cur");
			var str = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("src");
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#J_imgBooth").attr("src", str);
		});
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {});
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".nav li").hover(function () {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children(".dropdown-menu").slideDown(100);
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children("a").addClass("cur");
		}, function () {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".nav .dropdown-menu").hide();
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children("a").removeClass("cur");
		});

		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#mywxTab li a").hover(function (e) {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).tab('show');
			});
		});
	}
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'foot',
    data: function data() {
        return {
            src: '/static/img/logo.png',
            gongan: "/static/img/gongan.png"
        };
    }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            list: [{
                title: '餐饮外卖',
                content: '订单自动打印，省时、省力、更省心！'
            }, {
                title: '快递面单',
                content: '让快递方便快捷更高效'
            }, {
                title: '酒店',
                content: '一键订房，快速打印小票'
            }, {
                title: '加油站',
                content: '扫码付款，自动打印发票'
            }, {
                title: '微商城',
                content: '订单自动打印'
            }, {
                title: '无人便利店',
                content: '智慧新零售，门店解决方案'
            }, {
                title: '票务',
                content: '轻松打印门票、收据等'
            }, {
                title: '网络医院',
                content: '远程打印药方票据'
            }, {
                title: '教育',
                content: '文件、错题、答案打印'
            }, {
                title: '网店',
                content: '节省人手，提高效率'
            }]
        };
    }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {}
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            screenHeight: 0,
            handleType: 0,
            username: "",
            phone: "",
            pwd: "",
            showPwd: false,
            captchaCode: "",
            timeLeft: 0,
            timer: null,
            errMsg: ""
        };
    },
    mounted: function mounted() {
        this.screenHeight = document.body.clientHeight;
    },

    methods: {
        changeHandleType: function changeHandleType(type) {
            if (this.handleType != type) {
                this.handleType = type;
                this.username = "";
                this.phone = "";
                this.pwd = "";
                this.showPwd = false;
                this.captchaCode = "";
                this.errMsg = "";
            }
        },
        cleanUsername: function cleanUsername() {
            this.username = "";
        },
        cleanPhone: function cleanPhone() {
            this.phone = "";
        },
        cleanPwd: function cleanPwd() {
            this.pwd = "";
        },
        toggleEye: function toggleEye() {
            this.showPwd = !this.showPwd;
        },
        getCaptchaCode: function getCaptchaCode() {
            var _this = this;

            if (this.timeLeft > 0) {
                return;
            }
            if (!this.phone) {
                this.$showErrorMsg("请输入手机号码");
                return;
            }
            var reg = /^((13[0-9])|(14[5,7,9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-3,5-8])|(18[0-9])|(19[0,1,3,5-9]))\d{8}$/g;
            if (!reg.test(this.phone)) {
                this.$showErrorMsg("请输入正确的手机号码");
                return;
            }
            this.errMsg = "";
            this.timeLeft = 60;
            this.timer = setInterval(function () {
                _this.timeLeft--;
                if (_this.timeLeft == 0) {
                    clearInterval(_this.timer);
                }
            }, 1000);

            this.axios.post(this.$apiUrl + "/developcommon/getCaptcha", {
                phone: this.phone
            }).then(function (res) {
                if (res.data.code != 200) {
                    _this.$showErrorMsg(res.data.msg);
                } else {
                    _this.$showSuccessMsg("验证码已发送请注意查收");
                }
            });
        },
        register: function register() {
            var _this2 = this;

            if (!this.username) {
                this.$showErrorMsg("请输入用户名");
                return;
            }
            if (!this.phone) {
                this.$showErrorMsg("请输入手机号码");
                return;
            }
            var reg = /^((13[0-9])|(14[5,7,9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-3,5-8])|(18[0-9])|(19[0,1,3,5-9]))\d{8}$/g;
            if (!reg.test(this.phone)) {
                this.$showErrorMsg("请输入正确的手机号码");
                return;
            }
            if (!this.pwd) {
                this.$showErrorMsg("请输入密码");
                return;
            }
            if (this.pwd.length < 6) {
                this.$showErrorMsg("密码长度必须>=6");
                return;
            }
            if (!this.captchaCode) {
                this.$showErrorMsg("请输入验证码");
                return;
            }
            if (this.captchaCode.length != 6) {
                this.$showErrorMsg("请输入正确的验证码");
                return;
            }
            this.errMsg = "";

            this.axios.post(this.$apiUrl + "/developcommon/register", {
                name: this.username,
                mobile: this.phone,
                password: this.pwd,
                captchaCode: this.captchaCode
            }).then(function (res) {
                if (res.data.code != 200) {
                    _this2.$showErrorMsg(res.data.msg);
                } else {
                    _this2.$showSuccessMsg("恭喜您注册成功请登录~");
                    _this2.handleType = 0;
                    _this2.username = "";
                    _this2.showPwd = false;
                    _this2.captchaCode = "";
                    _this2.errMsg = "";
                }
            });
        },
        changePwd: function changePwd() {
            var _this3 = this;

            if (!this.phone) {
                this.$showErrorMsg("请输入手机号码");
                return;
            }
            var reg = /^((13[0-9])|(14[5,7,9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-3,5-8])|(18[0-9])|(19[0,1,3,5-9]))\d{8}$/g;
            if (!reg.test(this.phone)) {
                this.$showErrorMsg("请输入正确的手机号码");
                return;
            }
            if (!this.pwd) {
                this.$showErrorMsg("请输入密码");
                return;
            }
            if (this.pwd.length < 6) {
                this.$showErrorMsg("密码长度必须>=6");
                return;
            }
            if (!this.captchaCode) {
                this.$showErrorMsg("请输入验证码");
                return;
            }
            if (this.captchaCode.length != 6) {
                this.$showErrorMsg("请输入正确的验证码");
                return;
            }
            this.errMsg = "";

            this.axios.put(this.$apiUrl + "/developcommon/changPwd", {
                mobile: this.phone,
                password: this.pwd,
                captchaCode: this.captchaCode
            }).then(function (res) {
                if (res.data.code != 200) {
                    _this3.$showErrorMsg(res.data.msg);
                } else {
                    _this3.$showSuccessMsg("恭喜您密码修改成功请登录~");
                    _this3.handleType = 0;
                    _this3.username = "";
                    _this3.showPwd = false;
                    _this3.captchaCode = "";
                    _this3.errMsg = "";
                }
            });
        },
        login: function login() {
            var _this4 = this;

            if (!this.phone) {
                this.$showErrorMsg("请输入手机号码");
                return;
            }
            var reg = /^((13[0-9])|(14[5,7,9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-3,5-8])|(18[0-9])|(19[0,1,3,5-9]))\d{8}$/g;
            if (!reg.test(this.phone)) {
                this.$showErrorMsg("请输入正确的手机号码");
                return;
            }
            if (!this.pwd) {
                this.$showErrorMsg("请输入密码");
                return;
            }
            if (this.pwd.length < 6) {
                this.$showErrorMsg("密码长度必须>=6");
                return;
            }
            this.errMsg = "";

            this.axios.get(this.$apiUrl + "/developcommon/login", {
                params: {
                    phone: this.phone,
                    password: this.pwd
                }
            }).then(function (res) {
                if (res.data.code != 200) {
                    _this4.$showErrorMsg(res.data.msg);
                } else {
                    var result = res.data.data;
                    var developer = result.developer;
                    var appSecret = developer.appSecret;
                    var appSecretDot = appSecret.substr(0, 10) + "**********" + appSecret.substr(20);
                    developer.appSecretDot = appSecretDot;
                    sessionStorage.setItem("loginInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
                    _this4.$showSuccessMsg("登录成功");
                    _this4.pwd = "";
                    _this4.errMsg = "";
                    _this4.$router.push("/backend/index");
                }
            });
        }
    }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loginInfo: null,
            isLoading: false,
            headers: null,
            form: {
                backUrl: null
            },
            rule: {
                backUrl: [{ required: true, message: '请输入打印结果回调地址', trigger: 'blur' }, { pattern: /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/, message: '请检查回调地址格式是否正确', trigger: 'blur' }]
            }
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        this.loginInfo = JSON.parse(loginInfoStr);
        var developer = this.loginInfo.developer;
        this.form.backUrl = developer.backUrl;
        var token = this.loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
    },

    methods: {
        gotoDoc: function gotoDoc() {
            this.$emit("jump", "/open");
        },
        reloadCallbackUrl: function reloadCallbackUrl() {
            this.form.backUrl = this.loginInfo.developer.backUrl;
        },
        saveCallbackUrl: function saveCallbackUrl() {
            var _this = this;

            this.$refs["callbackForm"].validate(function (valid) {
                if (valid) {
                    _this.isLoading = true;

                    _this.axios.get(_this.form.backUrl).then(function (testRes) {
                        if (testRes.data != "ZONELINK-SUCCESS") {
                            var errMsg = "亲，GET 方法返回值不正确哦~";
                            _this.$message.error(errMsg);
                            _this.$showErrorMsg(errMsg);
                            _this.isLoading = false;
                        } else {
                            _this.$confirm('亲，是否确认保存当前回调地址？', '确认信息').then(function () {
                                _this.axios.put(_this.$apiUrl + "/developbackend/updateBackurl", _this.form, {
                                    headers: _this.headers
                                }).then(function (res) {
                                    if (res.data.code == 200) {
                                        _this.$message({
                                            message: '亲，恭喜您回调地址已成功更新啦~',
                                            type: 'success'
                                        });
                                        _this.$showSuccessMsg("亲，恭喜您回调地址已成功更新啦~");

                                        _this.loginInfo.developer.backUrl = _this.form.backUrl;
                                        sessionStorage.setItem("loginInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.loginInfo));
                                    } else {
                                        _this.$message.error(res.data.msg);
                                        _this.$showErrorMsg(res.data.msg);
                                    }
                                    _this.isLoading = false;
                                }).catch(function (e) {
                                    _this.$message.error(e.toString());
                                    _this.$showErrorMsg(e.toString());
                                    _this.isLoading = false;
                                });
                            }).catch(function () {
                                _this.isLoading = false;
                            });
                        }
                    }).catch(function (testErr) {
                        _this.isLoading = false;
                        _this.$message.error(testErr.toString());
                        _this.$showErrorMsg(testErr.toString());
                    });
                }
            });
        },
        deleteCallbackUrl: function deleteCallbackUrl() {
            var _this2 = this;

            this.$confirm('亲，是否确认删除当前回调地址？', '确认信息').then(function () {
                _this2.axios.delete(_this2.$apiUrl + "/developbackend/deleteBackurl/" + _this2.loginInfo.developer.id, {
                    headers: _this2.headers
                }).then(function (res) {
                    if (res.data.code == 200) {
                        _this2.$message({
                            message: '亲，恭喜您回调地址已成功删除啦~',
                            type: 'success'
                        });
                        _this2.$showSuccessMsg("亲，恭喜您回调地址已成功删除啦~");

                        _this2.loginInfo.developer.backUrl = null;
                        _this2.$refs.callbackForm.resetFields();
                        _this2.form.backUrl = "";
                        sessionStorage.setItem("loginInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.loginInfo));
                    } else {
                        _this2.$message.error(res.data.msg);
                        _this2.$showErrorMsg(res.data.msg);
                    }
                }).catch(function (e) {
                    _this2.$message.error(e.toString());
                    _this2.$showErrorMsg(e.toString());
                });
            }).catch(function () {});
        }
    }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showSecret: false,
            clipboard: null,
            loginInfo: null,
            developer: null,
            token: null,
            loginTimes: 1,
            config: null,
            dialogVisible: false,
            headers1: ["default_trade.jpg", "default_colleagues.jpg", "default_beauty.jpg"],
            headers2: ["default_family.jpg", "default_friend.jpg", "default_handsome.jpg"],
            currHeader: null,
            infoRule: {
                name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }, { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }],
                companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }, { min: 2, max: 32, message: '长度在 2 到 32 个字符', trigger: 'blur' }],
                address: [{ required: true, message: '请输入联系地址', trigger: 'blur' }, { min: 2, max: 64, message: '长度在 2 到 64 个字符', trigger: 'blur' }]
            },
            form: {
                oldPassword: "",
                newPassword: "",
                confirmPassword: ""
            },
            pwdRule: {
                oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }, { min: 6, max: 32, message: '密码长度在 6 到 32 个字符', trigger: 'blur' }],
                newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 6, max: 32, message: '密码长度在 6 到 32 个字符', trigger: 'blur' }],
                confirmPassword: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }, { min: 6, max: 32, message: '密码长度在 6 到 32 个字符', trigger: 'blur' }]
            }
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        this.loginInfo = JSON.parse(loginInfoStr);
        this.developer = this.loginInfo.developer;
        this.token = this.loginInfo.token;
        this.loginTimes = this.loginInfo.loginTimes;
        this.config = {
            headers: {
                "Zonelink-Id": this.developer.id,
                "Zonelink-Username": this.developer.mobile,
                "Zonelink-Password": this.developer.password,
                "Zonelink-Token": this.token
            }
        };
        this.currHeader = this.developer.header;
    },
    mounted: function mounted() {
        var _this = this;

        this.clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a(".icon-fuzhi");
        this.clipboard.on("success", function () {
            _this.$showSuccessMsg("亲，复制成功啦赶快去粘贴吧~");
        });
    },

    methods: {
        changeShowSecret: function changeShowSecret() {
            this.showSecret = !this.showSecret;
        },
        gotoLog: function gotoLog() {
            this.$emit("clickMenu", 7);
        },
        showHeaders: function showHeaders() {
            this.dialogVisible = true;
        },
        beforeClose: function beforeClose() {
            var _this2 = this;

            this.dialogVisible = false;
            setTimeout(function () {
                _this2.currHeader = _this2.developer.header;
            }, 500);
        },
        chooseHeader: function chooseHeader(header) {
            this.currHeader = "/headers/" + header;
        },
        saveInfo: function saveInfo(updateParams, msg, callback) {
            var _this3 = this;

            this.axios.put(this.$apiUrl + "/developbackend/setInfo", updateParams, this.config).then(function (res) {
                if (res.data.code == 403) {
                    _this3.$showErrorMsg(res.data.msg);
                    _this3.$router.push("/login");
                } else if (res.data.code != 200) {
                    _this3.$showSuccessMsg(res.data.msg);
                } else {
                    _this3.$showSuccessMsg(msg);
                    for (var key in updateParams) {
                        _this3.developer[key] = updateParams[key];
                    }
                    if (res.data.data && res.data.data.token) {
                        _this3.loginInfo.token = res.data.data.token;
                        _this3.config.headers.password = _this3.developer.password;
                        _this3.config.headers.token = res.data.data.token;
                    }
                    sessionStorage.setItem("loginInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.loginInfo));
                    if (callback) {
                        callback();
                    }
                }
            });
        },
        changeHeader: function changeHeader() {
            var _this4 = this;

            if (this.currHeader == this.developer.header) {
                this.dialogVisible = false;
            } else {
                this.saveInfo({ header: this.currHeader }, "头像修改成功", function () {
                    _this4.$emit("changeHeader", _this4.currHeader);
                    _this4.dialogVisible = false;
                });
            }
        },
        save: function save() {
            var _this5 = this;

            this.$refs["infoForm"].validate(function (valid) {
                if (valid) {
                    var params = {
                        name: _this5.developer.name,
                        companyName: _this5.developer.companyName,
                        address: _this5.developer.address
                    };
                    _this5.saveInfo(params, "基本信息修改成功", function () {
                        _this5.$emit("changeName", _this5.developer.name);
                    });
                }
            });
        },
        changePwd: function changePwd() {
            var _this6 = this;

            this.$refs["pwdForm"].validate(function (valid) {
                if (valid) {
                    if (_this6.form.oldPassword != _this6.developer.password) {
                        _this6.$showErrorMsg("旧密码输入错误");
                    } else if (_this6.form.newPassword != _this6.form.confirmPassword) {
                        _this6.$showErrorMsg("两次输入的密码不一致");
                    } else {
                        var params = {
                            password: _this6.form.newPassword
                        };
                        _this6.saveInfo(params, "基本信息修改成功");
                    }
                }
            });
        }
    },
    destroyed: function destroyed() {
        this.clipboard.destroy();
    }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            headers: null,
            queryParams: {
                pageNum: 1,
                orderNo: null,
                iccid: null,
                beginTime: null,
                endTime: null
            },
            rangeTime: [],
            total: 0,
            list: []
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        var loginInfo = JSON.parse(loginInfoStr);
        var developer = loginInfo.developer;
        var token = loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },

    methods: {
        handleSizeChange: function handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query: function query(pageNum) {
            var _this = this;

            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            if (null != this.rangeTime && "" != this.rangeTime) {
                this.queryParams.beginTime = this.rangeTime[0];
                var endTime = this.rangeTime[1];
                endTime = moment(endTime + " 00:00:00").add(1, 'd').format("YYYY-MM-DD");
                this.queryParams.endTime = endTime;
            } else {
                this.queryParams.beginTime = null;
                this.queryParams.endTime = null;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listSimDeposit", {
                params: this.queryParams,
                headers: this.headers
            }).then(function (res) {
                _this.loading = false;
                if (res.data.code == 200) {
                    _this.total = res.data.total;
                    var result = res.data.rows;
                    result.forEach(function (element) {
                        var simExpireTime = element.simExpireTime;
                        element.simExpireTime = moment(simExpireTime).format("YYYY-MM-DD");
                    });
                    _this.list = result;
                }
            });
        }
    }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showSecret: false,
            clipboard: null,
            developer: null,
            activeName: '1',
            logList: [],
            loginTimes: 1,
            printerCount: 0,
            activities: [{
                content: '优化开放平台用户体验，全新UI欢迎体验',
                timestamp: '2022-10-10',
                type: 'primary',
                icon: 'el-icon-more'
            }, {
                content: '上线打印结果回调功能',
                timestamp: '2021-11-11',
                type: 'success'
            }, {
                content: '完成 200+开发者接入',
                timestamp: '2021-06-01'
            }, {
                content: '云平台架构升级增强稳定性',
                timestamp: '2020-11-11'
            }, {
                content: '开放平台上线',
                timestamp: '2020-10-01'
            }, {
                content: '标签机完成测试',
                timestamp: '2020-06-01'
            }, {
                content: '小票机完成测试',
                timestamp: '2020-05-01'
            }, {
                content: '云打印机完成设计评审',
                timestamp: '2020-01-01'
            }, {
                content: '官网上线',
                timestamp: '2019-11-11'
            }, {
                content: '云打印开发团队成立',
                timestamp: '2019-09-01'
            }],
            shops: [{
                logo: "/static/img/alibaba.png",
                name: "阿里巴巴官方旗舰店",
                link: "https://www.zonelink.cc/"
            }, {
                logo: "/static/img/taobao.png",
                name: "淘宝官方旗舰店",
                link: "https://www.zonelink.cc/"
            }, {
                logo: "/static/img/pdd.png",
                name: "拼多多官方旗舰店",
                link: "https://www.zonelink.cc/"
            }, {
                logo: "/static/img/jd.png",
                name: "京东官方旗舰店",
                link: "https://www.zonelink.cc/"
            }]
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        var loginInfo = JSON.parse(loginInfoStr);
        this.developer = loginInfo.developer;
        this.logList = loginInfo.log;
        this.loginTimes = loginInfo.loginTimes;
        this.printerCount = loginInfo.printerCount;
    },
    mounted: function mounted() {
        var _this = this;

        this.clipboard = new __WEBPACK_IMPORTED_MODULE_0_clipboard___default.a(".icon-fuzhi");
        this.clipboard.on("success", function () {
            _this.$showSuccessMsg("亲，复制成功啦赶快去粘贴吧~");
        });
    },

    methods: {
        changeShowSecret: function changeShowSecret() {
            this.showSecret = !this.showSecret;
        },
        gotoCenter: function gotoCenter() {
            this.$emit("clickMenu", 8);
        },
        gotoLog: function gotoLog() {
            this.$emit("clickMenu", 7);
        },
        gotoPrinter: function gotoPrinter() {
            this.$emit("clickMenu", 1);
        },
        gotoShop: function gotoShop(url) {
            window.open(url, "_blank");
        }
    },
    destroyed: function destroyed() {
        this.clipboard.destroy();
    }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var moment = __webpack_require__(0);
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            headers: null,
            queryParams: {
                pageNum: 1,
                beginTime: null,
                endTime: null
            },
            rangeTime: [],
            total: 0,
            list: []
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        var loginInfo = JSON.parse(loginInfoStr);
        var developer = loginInfo.developer;
        var token = loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },

    methods: {
        getIndex: function getIndex($index) {
            return (this.queryParams.pageNum - 1) * this.queryParams.pageSize + $index + 1;
        },
        handleSizeChange: function handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query: function query(pageNum) {
            var _this = this;

            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            if (null != this.rangeTime && "" != this.rangeTime) {
                this.queryParams.beginTime = this.rangeTime[0];
                var endTime = this.rangeTime[1];
                endTime = moment(endTime + " 00:00:00").add(1, 'd').format("YYYY-MM-DD");
                this.queryParams.endTime = endTime;
            } else {
                this.queryParams.beginTime = null;
                this.queryParams.endTime = null;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listLog", {
                params: this.queryParams,
                headers: this.headers
            }).then(function (res) {
                _this.loading = false;
                if (res.data.code == 200) {
                    _this.total = res.data.total;
                    _this.list = res.data.rows;
                }
            });
        }
    }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard__);


var moment = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            clipboard: null,
            loading: false,
            headers: null,
            queryParams: {
                pageNum: 1,
                clientUsername: null,
                orderNo: null,
                beginTime: null,
                endTime: null
            },
            rangeTime: [],
            total: 0,
            list: [],
            detailVisible: false,
            taskContent: ""
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        var loginInfo = JSON.parse(loginInfoStr);
        var developer = loginInfo.developer;
        var token = loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },
    mounted: function mounted() {
        var _this = this;

        this.clipboard = new __WEBPACK_IMPORTED_MODULE_0_clipboard___default.a("#copy");
        this.clipboard.on("success", function () {
            _this.$showSuccessMsg("亲，复制成功啦赶快去粘贴吧~");
        });
    },
    destroyed: function destroyed() {
        this.clipboard.destroy();
    },

    methods: {
        handleSizeChange: function handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query: function query(pageNum) {
            var _this2 = this;

            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            if (null != this.rangeTime && "" != this.rangeTime && this.rangeTime.length == 2) {
                this.queryParams.beginTime = this.rangeTime[0];
                var endTime = this.rangeTime[1];
                endTime = moment(endTime + " 00:00:00").add(1, 'd').format("YYYY-MM-DD");
                this.queryParams.endTime = endTime;
            } else {
                this.queryParams.beginTime = null;
                this.queryParams.endTime = null;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listPrintTask", {
                params: this.queryParams,
                headers: this.headers
            }).then(function (res) {
                _this2.loading = false;
                if (res.data.code == 200) {
                    _this2.total = res.data.total;
                    var result = res.data.rows;
                    for (var i = 0; i < result.length; i++) {
                        var item = result[i];
                        if (item.completeTime) {
                            var diff = moment(item.completeTime).diff(moment(item.createTime), 's');
                            item.costTime = diff;
                        }
                    }
                    _this2.list = res.data.rows;
                }
            });
        },
        detail: function detail(item) {
            this.taskContent = item.content;
            this.detailVisible = true;
        },
        reprint: function reprint(developerPrintTaskId) {
            var _this3 = this;

            this.$confirm('亲，是否确认立即重打该任务？', '确认信息').then(function () {
                _this3.axios.post(_this3.$apiUrl + "/developbackend/reprint/" + developerPrintTaskId, {}, {
                    headers: _this3.headers
                }).then(function (res) {
                    if (res.data.code != 200) {
                        _this3.$showErrorMsg(res.data.msg);
                    } else {
                        _this3.$showSuccessMsg("亲，打印任务已重新下发啦~");
                        _this3.handleCurrentChange(1);
                    }
                });
            }).catch(function () {});
        },
        setComplete: function setComplete(developerPrintTask) {
            var _this4 = this;

            this.$confirm('亲，是否确认取消该打印任务？', '确认信息').then(function () {
                _this4.axios.put(_this4.$apiUrl + "/developbackend/deletePrintTask/" + developerPrintTask.id, {}, {
                    headers: _this4.headers
                }).then(function (res) {
                    if (res.data.code != 200) {
                        _this4.$showErrorMsg(res.data.msg);
                    } else {
                        developerPrintTask.status = 1;
                        _this4.$showSuccessMsg("亲，待打印任务已成功取消啦~");
                    }
                });
            }).catch(function () {});
        }
    }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isLoading: false,
            headers: null,
            form: {
                imei: null,
                orderNo: null,
                content: null,
                delay: null
            },
            rule: {
                imei: [{ required: true, message: '请输入设备编号(SN)', trigger: 'blur' }],
                content: [{ required: true, message: '请输入打印内容', trigger: 'blur' }, { min: 1, max: 2500, message: '密码长度在 1 到 2500 个字符', trigger: 'blur' }]
            }
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        this.loginInfo = JSON.parse(loginInfoStr);
        var developer = this.loginInfo.developer;
        var token = this.loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
    },

    methods: {
        handleTest: function handleTest() {
            var _this = this;

            this.$refs["printTestForm"].validate(function (valid) {
                if (valid) {
                    _this.isLoading = true;
                    var params = {
                        imei: _this.form.imei,
                        orderNo: _this.form.orderNo,
                        delay: _this.form.delay,
                        content: _this.form.content
                    };
                    _this.axios.post(_this.$apiUrl + "/developbackend/printTest", params, {
                        headers: _this.headers
                    }).then(function (res) {
                        if (res.data.code == 200) {
                            _this.$showSuccessMsg("亲，打印任务已成功下发啦~");
                        } else {
                            _this.$showErrorMsg(res.data.msg);
                        }
                        _this.isLoading = false;
                    }).catch(function (e) {
                        _this.$showErrorMsg(e.toString());
                        _this.isLoading = false;
                    });
                }
            });
        },
        reset: function reset() {
            this.form = {
                imei: null,
                orderNo: null,
                content: null,
                delay: null
            };
            this.$refs.printTestForm.resetFields();
        }
    }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loginInfo: null,
            loading: false,
            headers: null,
            queryParams: {
                pageNum: 1,
                online: null,
                status: null,
                imei: null,
                name: null
            },
            total: 0,
            onlineOptions: [{
                value: 1,
                label: "在线"
            }, {
                value: 0,
                label: "离线"
            }],
            statusOptions: [{
                value: 1,
                label: "正常"
            }, {
                value: 0,
                label: "异常"
            }],
            list: [],
            dialogFormVisible: false,
            title: "添加设备",
            form: {
                id: null,
                imei: null,
                printerName: null
            },
            rules: {
                imei: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
                printerName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }, { min: 2, max: 64, message: '长度在 2 到 64 个字符', trigger: 'blur' }]
            },
            currPrinter: null
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        this.loginInfo = JSON.parse(loginInfoStr);
        var developer = this.loginInfo.developer;
        var token = this.loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },

    methods: {
        handleSizeChange: function handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query: function query(pageNum) {
            var _this = this;

            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listPrinter", {
                params: this.queryParams,
                headers: this.headers
            }).then(function (res) {
                _this.loading = false;
                if (res.data.code == 200) {
                    _this.total = res.data.total;
                    _this.list = res.data.rows;
                } else if (res.data.code == 403) {
                    _this.$showErrorMsg(res.data.msg);

                    sessionStorage.removeItem("loginInfo");
                    _this.$router.push("/login");
                } else {
                    _this.$showErrorMsg(res.data.msg);
                }
            });
        },
        showForm: function showForm(item) {
            this.dialogFormVisible = true;
            if (item) {
                this.form = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
                this.title = "设置设备名称";
            } else {
                this.title = "添加设备";
            }
        },
        handleClose: function handleClose() {
            this.form = {
                id: null,
                imei: null,
                printerName: null
            };
            this.$refs.infoForm.resetFields();
            this.dialogFormVisible = false;
        },
        handleSubmit: function handleSubmit() {
            var _this2 = this;

            this.$refs["infoForm"].validate(function (valid) {
                if (valid) {
                    if (_this2.form.id) {
                        _this2.handleEdit();
                    } else {
                        _this2.handleAdd();
                    }
                }
            });
        },
        handleAdd: function handleAdd() {
            var _this3 = this;

            this.axios.post(this.$apiUrl + "/developbackend/addPrinter", this.form, {
                headers: this.headers
            }).then(function (res) {
                if (res.data.code != 200) {
                    _this3.$showErrorMsg(res.data.msg);
                } else {
                    _this3.$showSuccessMsg("恭喜您，绑定成功啦~");
                    _this3.dialogFormVisible = false;
                    _this3.handleCurrentChange(1);

                    _this3.asyncPrinterCount(1);
                }
            });
        },
        handleEdit: function handleEdit() {
            var _this4 = this;

            this.axios.put(this.$apiUrl + "/developbackend/editPrinterName", this.form, {
                headers: this.headers
            }).then(function (res) {
                if (res.data.code != 200) {
                    _this4.$showErrorMsg(res.data.msg);
                } else {
                    _this4.$showSuccessMsg("恭喜您，设置设备名称成功啦~");
                    _this4.dialogFormVisible = false;
                    _this4.query();
                }
            });
        },
        handleRefresh: function handleRefresh() {
            this.query();
        },
        setCurrPrinter: function setCurrPrinter(item) {
            this.currPrinter = item;
        },
        handleCommand: function handleCommand(command) {
            var _this5 = this;

            var printContent = "";
            if (command == 'text') {
                printContent = "亲，欢迎使用众联云打印服务，测试打印正常。";
            } else if (command == 'textCut') {
                printContent = "亲，欢迎使用众联云打印服务，测试打印正常。<CUT>";
            } else if (command == 'newOrder') {
                printContent = "<PLMC>c1</PLMC><517><CB><BOLD>\u65B0\u8BA2\u5355\u6D4B\u8BD5</BOLD></CB><C>* \u4F0D\u5E7A\u67D2\u6F14\u793A\u5E97\u94FA *</C><CL>#\u53481 \u9884\u8BA2\u5355</CL><HP>";
            } else if (command == 'realOrder') {
                printContent = "<PLMC>c1</PLMC><517><CB><BOLD>\u963F\u91CC\u90CE</BOLD></CB><C>* \u70E7\u70E4\u5927\u53A8 *</C><CL>\u5348#2 \u9884\u8BA2\u5355</CL><CL>\u4ECA\u592911:00\u9001\u8FBE</CL><CB>--\u5DF2\u5728\u7EBF\u652F\u4ED8--</CB><LINE->\u8BA2\u5355\u7F16\u53F7\uFF1A23081627042080017011<BR>\u5546\u5BB6\u7535\u8BDD\uFF1A13600093009<BR>\u5BA2\u670D\u7535\u8BDD\uFF1A18138794144<BR>\u4E0B\u5355\u7535\u8BDD\uFF1A18138794144<BR>\u4E0B\u5355\u65F6\u95F4\uFF1A2023-08-16 00:08:42<BR><LINE-><GROUP><LINE><ITEM>\u62DB\u724C\u70E4\u80A0(\u5FC5\u9009\u8D77\u8D2D5)</ITEM><ITEM>x5</ITEM><ITEM>\uFFE510.8\u5143</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>\u9E21\u6252\u996D</ITEM><ITEM>x1</ITEM><ITEM>\uFFE515.8\u5143</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>\u871C\u6C41\u53C9\u70E7\u996D+\u8001\u706B\u6C64</ITEM><ITEM>x1</ITEM><ITEM>\uFFE521.8\u5143</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>\u5546\u54C1\u4EF7</ITEM><ITEM>\uFFE50.0\u5143</ITEM></LINE><LINE><ITEM>\u5305\u88C5\u8D39</ITEM><ITEM>\uFFE50.0\u5143</ITEM></LINE><LINE><ITEM>\u914D\u9001\u8D39</ITEM><ITEM>\uFFE50.0\u5143</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>\u5BA2\u6237\u5B9E\u4ED8</ITEM><ITEM>\uFFE50.0\u5143</ITEM></LINE></GROUP><LINE-><B>\u6F14\u793A\u7B2C\u4E00\u4E2A\u5206\u533A\u7B2C\u4E00\u5206\u533A\u7B2C\u4E00\u697C7\u697C777<BR>\u718A\u5927<BR>13600093009</B><BR><LINE-><C><QRCODE>23081627042080017011</QRCODE></C><TITLE> #2\u5B8C </TITLE><HP>";
            } else if (command == 'realOrderCut') {
                printContent = "<PLMC>c1</PLMC><517><CB><BOLD>\u963F\u91CC\u90CE</BOLD></CB><C>* \u70E7\u70E4\u5927\u53A8 *</C><CL>\u5348#2 \u9884\u8BA2\u5355</CL><CL>\u4ECA\u592911:00\u9001\u8FBE</CL><CB>--\u5DF2\u5728\u7EBF\u652F\u4ED8--</CB><LINE->\u8BA2\u5355\u7F16\u53F7\uFF1A23081627042080017011<BR>\u5546\u5BB6\u7535\u8BDD\uFF1A13600093009<BR>\u5BA2\u670D\u7535\u8BDD\uFF1A18138794144<BR>\u4E0B\u5355\u7535\u8BDD\uFF1A18138794144<BR>\u4E0B\u5355\u65F6\u95F4\uFF1A2023-08-16 00:08:42<BR><LINE-><GROUP><LINE><ITEM>\u62DB\u724C\u70E4\u80A0(\u5FC5\u9009\u8D77\u8D2D5)</ITEM><ITEM>x5</ITEM><ITEM>\uFFE510.8\u5143</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>\u9E21\u6252\u996D</ITEM><ITEM>x1</ITEM><ITEM>\uFFE515.8\u5143</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>\u871C\u6C41\u53C9\u70E7\u996D+\u8001\u706B\u6C64</ITEM><ITEM>x1</ITEM><ITEM>\uFFE521.8\u5143</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>\u5546\u54C1\u4EF7</ITEM><ITEM>\uFFE50.0\u5143</ITEM></LINE><LINE><ITEM>\u5305\u88C5\u8D39</ITEM><ITEM>\uFFE50.0\u5143</ITEM></LINE><LINE><ITEM>\u914D\u9001\u8D39</ITEM><ITEM>\uFFE50.0\u5143</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>\u5BA2\u6237\u5B9E\u4ED8</ITEM><ITEM>\uFFE50.0\u5143</ITEM></LINE></GROUP><LINE-><B>\u6F14\u793A\u7B2C\u4E00\u4E2A\u5206\u533A\u7B2C\u4E00\u5206\u533A\u7B2C\u4E00\u697C7\u697C777<BR>\u718A\u5927<BR>13600093009</B><BR><LINE-><C><QRCODE>23081627042080017011</QRCODE></C><TITLE> #2\u5B8C </TITLE><HP><CUT>";
            } else if (command == 'hurryOrder') {
                printContent = "<PLMC>c4</PLMC><CB><BOLD>\u6D4B\u8BD5\u6253\u5370\u50AC\u5355</BOLD></CB>";
            } else if (command == 'cancelOrderApply') {
                printContent = "<PLMC>c5</PLMC><CB><BOLD>\u6D4B\u8BD5\u6253\u5370\u7533\u8BF7\u53D6\u6D88\u8BA2\u5355</BOLD></CB>";
            } else if (command == 'cancelOrder') {
                printContent = "<PLMC>c6</PLMC><CB><BOLD>\u6D4B\u8BD5\u8BA2\u5355\u5DF2\u53D6\u6D88</BOLD></CB>";
            } else if (command == 'refundOrder') {
                printContent = "<PLMC>c7</PLMC><CB><BOLD>\u6D4B\u8BD5\u8BA2\u5355\u5DF2\u9000\u6B3E</BOLD></CB>";
            } else if (command == 'advanceOrder') {
                printContent = "<PLMC>c8</PLMC><CB><BOLD>\u6D4B\u8BD5\u5F85\u5904\u7406\u9884\u7EA6\u5355</BOLD></CB>";
            } else if (command == 'newNotice') {
                printContent = "<PLMC>cb</PLMC><CB><BOLD>\u6D4B\u8BD5\u65B0\u6D88\u606F\u63D0\u9192</BOLD></CB>";
            } else if (command == '517') {
                printContent = "<517>";
            } else if (command == 'HP') {
                printContent = "<HP>";
            } else if (command == 'JD') {
                printContent = "<JDWM>";
            }

            var params = {
                imei: this.currPrinter.imei,
                developerPrinterId: this.currPrinter.id,
                content: printContent
            };
            this.axios.post(this.$apiUrl + "/developbackend/printTest", params, {
                headers: this.headers
            }).then(function (res) {
                if (res.data.code == 420) {
                    _this5.$showErrorMsg(res.data.msg);
                    _this5.currPrinter.online = 0;
                } else if (res.data.code == 421) {
                    _this5.$showErrorMsg(res.data.msg);
                    _this5.currPrinter.status = 0;
                } else if (res.data.code == 200) {
                    _this5.$showSuccessMsg("亲，打印任务已成功下发啦~");
                } else {
                    _this5.$showErrorMsg(res.data.msg);
                }
            });
        },
        handleClear: function handleClear(developerPrinter) {
            var _this6 = this;

            this.$confirm('亲，是否确认清空该设备的待打印任务？', '确认信息').then(function () {
                _this6.axios.put(_this6.$apiUrl + "/developbackend/cleanPrintTask/" + developerPrinter.id, {}, {
                    headers: _this6.headers
                }).then(function (res) {
                    if (res.data.code != 200) {
                        _this6.$showErrorMsg(res.data.msg);
                    } else {
                        developerPrinter.toPrintTaskCount = 0;
                        _this6.$showSuccessMsg("亲，待打印任务已成功清空啦~");
                    }
                });
            }).catch(function () {});
        },
        handleDelete: function handleDelete(developerPrinterId) {
            var _this7 = this;

            this.$confirm('亲，是否确认解绑该设备？', '确认信息').then(function () {
                _this7.axios.delete(_this7.$apiUrl + "/developbackend/removePrinter/" + developerPrinterId, {
                    headers: _this7.headers
                }).then(function (res) {
                    if (res.data.code != 200) {
                        _this7.$showErrorMsg(res.data.msg);
                    } else {
                        _this7.$showSuccessMsg("亲，您的设备已成功解绑啦~");
                        _this7.handleCurrentChange(1);

                        _this7.asyncPrinterCount(-1);
                    }
                });
            }).catch(function () {});
        },
        asyncPrinterCount: function asyncPrinterCount(val) {
            this.loginInfo.printerCount += val;
            sessionStorage.setItem("loginInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.loginInfo));
        }
    }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            headers: null,
            statusOptions: [{
                value: 1,
                label: "正常（过期时间>=30天）"
            }, {
                value: 2,
                label: "即将到期（过期时间<30天）"
            }, {
                value: 3,
                label: "正常+即将到期"
            }, {
                value: 4,
                label: "已过期"
            }],
            queryParams: {
                pageNum: 1,
                printerUsername: null,
                iccid: null,
                simStatus: null
            },
            total: 0,
            list: []
        };
    },
    created: function created() {
        var loginInfoStr = sessionStorage.getItem("loginInfo");
        var loginInfo = JSON.parse(loginInfoStr);
        var developer = loginInfo.developer;
        var token = loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },

    methods: {
        handleSizeChange: function handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query: function query(pageNum) {
            var _this = this;

            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listSim", {
                params: this.queryParams,
                headers: this.headers
            }).then(function (res) {
                _this.loading = false;
                if (res.data.code == 200) {
                    _this.total = res.data.total;
                    var result = res.data.rows;
                    result.forEach(function (element) {
                        var simExpireTime = element.simExpireTime;
                        element.simExpireTime = moment(simExpireTime).format("YYYY-MM-DD");
                        var diffDay = moment(simExpireTime).diff(moment(), 'days');
                        if (diffDay < 0) {
                            element.simStatus = 4;
                        } else if (diffDay < 30) {
                            element.simStatus = 2;
                        } else {
                            element.simStatus = 1;
                        }
                    });
                    _this.list = result;
                }
            });
        },
        showForm: function showForm() {
            this.$showWarnMsg("亲，此功能暂未开放哦~");
        }
    }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
            function myfunction(li, li_a, menu_tab) {
                li.click(function () {
                    var index = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).index();
                    menu_tab.eq(index).addClass("active").siblings().removeClass("active");
                    li_a.removeClass("selected");
                    li_a.eq(index).addClass("selected").siblings().removeClass("selected");
                });
            }
            myfunction(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu .ulmenu0 li"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .ulmenu0 li a"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .menu0 .tab"));
            myfunction(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu .ulmenu1 li"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .ulmenu1 li a"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .menu1 .tab"));
            myfunction(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu .ulmenu2 li"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .ulmenu2 li a"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .menu2 .tab"));
            myfunction(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu .ulmenu3 li"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .ulmenu3 li a"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .menu3 .tab"));
            myfunction(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu .ulmenu4 li"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .ulmenu4 li a"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .menu4 .tab"));
            myfunction(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu .ulmenu5 li"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .ulmenu5 li a"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .menu5 .tab"));
            myfunction(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu .ulmenu6 li"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .ulmenu6 li a"), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .menu6 .tab"));
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".menu > ul").eq(0).show();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".menu h3").click(function () {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("onleft").siblings().removeClass('onleft');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".menu_tab > div").removeClass("active");
                    var val = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).next().attr('class');
                    var menu_value = val.substring(val.length - 1);
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .menu" + menu_value + " .tab:first-child").addClass("active");
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu .ulmenu" + menu_value + " li>a").removeClass("selected");
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu .ulmenu" + menu_value + " li a").eq(0).addClass("selected");
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).next().stop().slideToggle();
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).siblings().next("ul").stop().slideUp();
                });
            });
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .menu > h3").click(function () {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .A1").empty().text(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text());
                });
            });
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".panel .panel-collapse panel-coll2:eq(0)").show();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".panel").click(function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).siblings('.panel').removeClass('current');
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('current');
            });
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".qm_href").click(function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".onleft").removeClass("onleft");
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".menu > ul").hide();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".menu_tab > div").removeClass("active");
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".menu > ul").eq(2).show();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".menu > h3").eq(2).addClass("onleft");
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qm_href").click();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".container .content2_he .A1").empty().text(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".menu > h3").eq(2).text());
            });
        });
    },

    methods: {
        showCallback: function showCallback() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".menu h3").eq(2).click();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#callback").click();
        }
    }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	}
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css__);




var imgArr = [{
	src: '/static/img/home_bg1.jpg'
}, {
	src: '/static/img/home_bg2.jpg'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'swipe',
	components: {
		swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
		swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
	},
	data: function data() {
		return {
			swiperOption: {
				pagination: '.swiper-pagination',
				paginationClickable: true,
				autoplay: 5000
			},
			imgArr: imgArr
		};
	}
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(17);


var navItems = [{
    text: '官网首页',
    link: '/'
}, {
    text: '应用场景',
    link: '/aps'
}, {
    text: '产品简介',
    link: '/brief'
}, {
    text: '开放平台',
    link: '/open'
}, {
    text: '加盟合作',
    link: '/cooperation'
}, {
    text: '联系我们',
    link: '/contact'
}];


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'topHeader',
    data: function data() {
        return {
            navItems: navItems,
            navIn: 'nav-out',
            menu: ['dropdown-menu', 'dropdown-menu-item'],
            showService: true
        };
    },

    watch: {
        $route: function $route(to) {
            this.toggleShowService(to.path);
        }
    },
    mounted: function mounted() {
        this.toggleShowService(this.$route.path);

        var path = this.$route.path;
        var index = navItems.findIndex(function (item) {
            return item.link == path;
        });
        var $event = document.querySelector('.nav-item li:nth-child(' + (index + 1) + ')');

        if ($event && $event.classList) {
            $event.classList.add('selected');
        }

        $('#top-back').hide();
        $(window).scroll(function () {
            if ($(this).scrollTop() > 350) {
                $("#top-back").fadeIn();
            } else {
                $("#top-back").fadeOut();
            }
        });

        function topBack() {
            $('body,html').animate({ scrollTop: 0 }, 300);
        }
    },

    methods: {
        toggleShowService: function toggleShowService(path) {
            if (path.indexOf("/login") == 0 || path.indexOf("/backend") == 0) {
                this.showService = false;
            } else {
                this.showService = true;
            }
        },
        topBack: function topBack() {
            document.body.scrollIntoView();
        },
        jump: function jump(path) {
            [].forEach.call(document.getElementsByTagName('li'), function (item) {
                item.className = '';
            });
            var $event = document.querySelector('.nav-item li:nth-child(3)');

            $event.classList.add('selected');
            this.$router.push(path);
        },
        toLink: function toLink(link, $event) {
            var className = $event.target.className;
            if (this.menu.includes(className.trim())) {
                return;
            }

            [].forEach.call(document.getElementsByTagName('li'), function (item) {
                item.className = '';
            });
            if (link == '/login' || link == '/backend/index') {
                __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push(link || '/');
            } else {
                __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push(link || '/');
                $event.target.className = 'selected';
            }
        },
        gotoBackend: function gotoBackend(e) {
            var cacheDeveloper = sessionStorage.getItem("loginInfo");
            if (cacheDeveloper) {
                this.toLink("/backend/index", e);
            } else {
                this.toLink("/login", e);
            }
        },
        addClass: function addClass($event) {
            var className = $event.target.className;
            if (this.menu.includes(className.trim())) {
                return;
            }

            if (!className.match(new RegExp('(\\s|^)' + 'selected' + '(\\s|$)'))) {
                $event.target.className = ' ';
            }
            if (!className.match(new RegExp('(\\s|^)' + 'nav-in' + '(\\s|$)'))) {
                $event.target.className += ' ' + 'nav-in';
            }
        },
        rmClass: function rmClass($event) {
            var className = $event.target.className;
            if (this.menu.includes(className.trim())) {
                return;
            }
            if (!className.match(new RegExp('(\\s|^)' + 'selected' + '(\\s|$)'))) {
                $event.target.className = ' ';
            }
            if (!className.match(new RegExp('(\\s|^)' + 'nav-out' + '(\\s|$)'))) {
                $event.target.className += ' ' + 'nav-out';
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_fonts_iconfont_css__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_fonts_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_fonts_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_css_npage_css__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_css_npage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_css_npage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_css_animate_min_css__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_bootstrap_min_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_css_open_css__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_css_open_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_css_open_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_style_css__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_css_style_css__);


















var env = "production";

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$showService = true;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$apiUrl = env == 'development' ? "http://devopen.zonelink.cc" : "https://open.zonelink.cc";
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$pageSizes = [10, 20, 50];
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$showSuccessMsg = function (msg) {
  this.$notify({
    type: "success",
    title: "通知：",
    message: msg,
    position: 'bottom-right',
    duration: 2000
  });
};
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$showWarnMsg = function (msg) {
  this.$notify({
    type: "warning",
    title: "错误提示：",
    message: msg,
    position: 'bottom-right',
    duration: 2000
  });
};
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$showErrorMsg = function (msg) {
  this.$notify({
    type: "error",
    title: "错误提示：",
    message: msg,
    position: 'bottom-right',
    duration: 2000
  });
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$dateQuickPickerOptions = {
  shortcuts: [{
    text: '最近一周',
    onClick: function onClick(picker) {
      var end = new Date();
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一个月',
    onClick: function onClick(picker) {
      var end = new Date();
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近三个月',
    onClick: function onClick(picker) {
      var end = new Date();
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit('pick', [start, end]);
    }
  }]
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$printTags = [{
  label: "<ZLY>",
  tips: "众联云助手微信公众号二维码"
}, {
  label: "<WDM>",
  tips: "五斗米助手微信公众号二维码"
}, {
  label: "<PLMC>xx</PLMC>",
  tips: "语音播报，c1:新订单，c4:催单，c5:申请取消订单，c6:订单已取消，c7:订单已退款，c8:待处理预约单，cb新的消息提醒"
}, {
  label: "<BR>",
  tips: "换行符"
}, {
  label: "<LINE->",
  tips: "分隔符“-”，自适应纸宽，效果 --------------------------------"
}, {
  label: "<LINE*>",
  tips: "分隔符“*”，自适应纸宽，效果 ********************************"
}, {
  label: "<LINE#>",
  tips: "分隔符“#”，自适应纸宽，效果 ################################"
}, {
  label: "<LINE=>",
  tips: "分隔符“=”，自适应纸宽，效果 ================================"
}, {
  label: "<TITLE>xx</TITLE>",
  tips: "标题，自适应纸宽，效果 ------------- 备注 -------------"
}, {
  label: "<GROUP>xx</GROUP>",
  tips: "分组，配合下面的<LINE>配合使用，效果     鸡扒饭     x1  ￥15.8元"
}, {
  label: "<LINE>xx</LINE>",
  tips: "占满一行的条目数据，配合下面的<ITEM>配合使用，譬如：<LINE><ITEM>鸡扒饭</ITEM><ITEM>x1</ITEM><ITEM>￥15.8元</ITEM></LINE>"
}, {
  label: "<ITEM>xx</ITEM>",
  tips: "行数据条目，譬如：<ITEM>鸡扒饭</ITEM><ITEM>x1</ITEM><ITEM>￥15.8元</ITEM>"
}, {
  label: "<CUT>",
  tips: "自动切纸（仅限切刀设备使用才有效果）"
}, {
  label: "<C></C>",
  tips: "居中，自动换行不用跟着加<BR>"
}, {
  label: "<RIGHT></RIGHT>",
  tips: "右对齐，自动换行不用跟着加<BR>"
}, {
  label: "<M></M>",
  tips: "中号字体"
}, {
  label: "<CM></CM>",
  tips: "居中 + 中号字体，自动换行不用跟着加<BR>"
}, {
  label: "<B></B>",
  tips: "大号字体"
}, {
  label: "<CB></CB>",
  tips: "居中 + 大号字体，自动换行不用跟着加<BR>"
}, {
  label: "<W></W>",
  tips: "倍宽"
}, {
  label: "<CW></CW>",
  tips: "居中 + 倍宽，自动换行不用跟着加<BR>"
}, {
  label: "<BOLD></BOLD>",
  tips: "字体加粗，标签嵌套的时候需要放在最内层，如：<CB><BOLD>众联云</BOLD></CB>"
}, {
  label: "<REV></REV>",
  tips: "黑白反打"
}, {
  label: "<QRCODE></QRCODE>",
  tips: "二维码"
}, {
  label: "<BARCODE></BARCODE>",
  tips: "条形码"
}, {
  label: "<HP>",
  tips: "好评图片"
}, {
  label: "<517>",
  tips: "伍幺柒外卖LOGO"
}, {
  label: "<JDWM>",
  tips: "京东外卖LOGO"
}];

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 32,
	"./af.js": 32,
	"./ar": 39,
	"./ar-dz": 33,
	"./ar-dz.js": 33,
	"./ar-kw": 34,
	"./ar-kw.js": 34,
	"./ar-ly": 35,
	"./ar-ly.js": 35,
	"./ar-ma": 36,
	"./ar-ma.js": 36,
	"./ar-sa": 37,
	"./ar-sa.js": 37,
	"./ar-tn": 38,
	"./ar-tn.js": 38,
	"./ar.js": 39,
	"./az": 40,
	"./az.js": 40,
	"./be": 41,
	"./be.js": 41,
	"./bg": 42,
	"./bg.js": 42,
	"./bm": 43,
	"./bm.js": 43,
	"./bn": 45,
	"./bn-bd": 44,
	"./bn-bd.js": 44,
	"./bn.js": 45,
	"./bo": 46,
	"./bo.js": 46,
	"./br": 47,
	"./br.js": 47,
	"./bs": 48,
	"./bs.js": 48,
	"./ca": 49,
	"./ca.js": 49,
	"./cs": 50,
	"./cs.js": 50,
	"./cv": 51,
	"./cv.js": 51,
	"./cy": 52,
	"./cy.js": 52,
	"./da": 53,
	"./da.js": 53,
	"./de": 56,
	"./de-at": 54,
	"./de-at.js": 54,
	"./de-ch": 55,
	"./de-ch.js": 55,
	"./de.js": 56,
	"./dv": 57,
	"./dv.js": 57,
	"./el": 58,
	"./el.js": 58,
	"./en-au": 59,
	"./en-au.js": 59,
	"./en-ca": 60,
	"./en-ca.js": 60,
	"./en-gb": 61,
	"./en-gb.js": 61,
	"./en-ie": 62,
	"./en-ie.js": 62,
	"./en-il": 63,
	"./en-il.js": 63,
	"./en-in": 64,
	"./en-in.js": 64,
	"./en-nz": 65,
	"./en-nz.js": 65,
	"./en-sg": 66,
	"./en-sg.js": 66,
	"./eo": 67,
	"./eo.js": 67,
	"./es": 71,
	"./es-do": 68,
	"./es-do.js": 68,
	"./es-mx": 69,
	"./es-mx.js": 69,
	"./es-us": 70,
	"./es-us.js": 70,
	"./es.js": 71,
	"./et": 72,
	"./et.js": 72,
	"./eu": 73,
	"./eu.js": 73,
	"./fa": 74,
	"./fa.js": 74,
	"./fi": 75,
	"./fi.js": 75,
	"./fil": 76,
	"./fil.js": 76,
	"./fo": 77,
	"./fo.js": 77,
	"./fr": 80,
	"./fr-ca": 78,
	"./fr-ca.js": 78,
	"./fr-ch": 79,
	"./fr-ch.js": 79,
	"./fr.js": 80,
	"./fy": 81,
	"./fy.js": 81,
	"./ga": 82,
	"./ga.js": 82,
	"./gd": 83,
	"./gd.js": 83,
	"./gl": 84,
	"./gl.js": 84,
	"./gom-deva": 85,
	"./gom-deva.js": 85,
	"./gom-latn": 86,
	"./gom-latn.js": 86,
	"./gu": 87,
	"./gu.js": 87,
	"./he": 88,
	"./he.js": 88,
	"./hi": 89,
	"./hi.js": 89,
	"./hr": 90,
	"./hr.js": 90,
	"./hu": 91,
	"./hu.js": 91,
	"./hy-am": 92,
	"./hy-am.js": 92,
	"./id": 93,
	"./id.js": 93,
	"./is": 94,
	"./is.js": 94,
	"./it": 96,
	"./it-ch": 95,
	"./it-ch.js": 95,
	"./it.js": 96,
	"./ja": 97,
	"./ja.js": 97,
	"./jv": 98,
	"./jv.js": 98,
	"./ka": 99,
	"./ka.js": 99,
	"./kk": 100,
	"./kk.js": 100,
	"./km": 101,
	"./km.js": 101,
	"./kn": 102,
	"./kn.js": 102,
	"./ko": 103,
	"./ko.js": 103,
	"./ku": 104,
	"./ku.js": 104,
	"./ky": 105,
	"./ky.js": 105,
	"./lb": 106,
	"./lb.js": 106,
	"./lo": 107,
	"./lo.js": 107,
	"./lt": 108,
	"./lt.js": 108,
	"./lv": 109,
	"./lv.js": 109,
	"./me": 110,
	"./me.js": 110,
	"./mi": 111,
	"./mi.js": 111,
	"./mk": 112,
	"./mk.js": 112,
	"./ml": 113,
	"./ml.js": 113,
	"./mn": 114,
	"./mn.js": 114,
	"./mr": 115,
	"./mr.js": 115,
	"./ms": 117,
	"./ms-my": 116,
	"./ms-my.js": 116,
	"./ms.js": 117,
	"./mt": 118,
	"./mt.js": 118,
	"./my": 119,
	"./my.js": 119,
	"./nb": 120,
	"./nb.js": 120,
	"./ne": 121,
	"./ne.js": 121,
	"./nl": 123,
	"./nl-be": 122,
	"./nl-be.js": 122,
	"./nl.js": 123,
	"./nn": 124,
	"./nn.js": 124,
	"./oc-lnc": 125,
	"./oc-lnc.js": 125,
	"./pa-in": 126,
	"./pa-in.js": 126,
	"./pl": 127,
	"./pl.js": 127,
	"./pt": 129,
	"./pt-br": 128,
	"./pt-br.js": 128,
	"./pt.js": 129,
	"./ro": 130,
	"./ro.js": 130,
	"./ru": 131,
	"./ru.js": 131,
	"./sd": 132,
	"./sd.js": 132,
	"./se": 133,
	"./se.js": 133,
	"./si": 134,
	"./si.js": 134,
	"./sk": 135,
	"./sk.js": 135,
	"./sl": 136,
	"./sl.js": 136,
	"./sq": 137,
	"./sq.js": 137,
	"./sr": 139,
	"./sr-cyrl": 138,
	"./sr-cyrl.js": 138,
	"./sr.js": 139,
	"./ss": 140,
	"./ss.js": 140,
	"./sv": 141,
	"./sv.js": 141,
	"./sw": 142,
	"./sw.js": 142,
	"./ta": 143,
	"./ta.js": 143,
	"./te": 144,
	"./te.js": 144,
	"./tet": 145,
	"./tet.js": 145,
	"./tg": 146,
	"./tg.js": 146,
	"./th": 147,
	"./th.js": 147,
	"./tk": 148,
	"./tk.js": 148,
	"./tl-ph": 149,
	"./tl-ph.js": 149,
	"./tlh": 150,
	"./tlh.js": 150,
	"./tr": 151,
	"./tr.js": 151,
	"./tzl": 152,
	"./tzl.js": 152,
	"./tzm": 154,
	"./tzm-latn": 153,
	"./tzm-latn.js": 153,
	"./tzm.js": 154,
	"./ug-cn": 155,
	"./ug-cn.js": 155,
	"./uk": 156,
	"./uk.js": 156,
	"./ur": 157,
	"./ur.js": 157,
	"./uz": 159,
	"./uz-latn": 158,
	"./uz-latn.js": 158,
	"./uz.js": 159,
	"./vi": 160,
	"./vi.js": 160,
	"./x-pseudo": 161,
	"./x-pseudo.js": 161,
	"./yo": 162,
	"./yo.js": 162,
	"./zh-cn": 163,
	"./zh-cn.js": 163,
	"./zh-hk": 164,
	"./zh-hk.js": 164,
	"./zh-mo": 165,
	"./zh-mo.js": 165,
	"./zh-tw": 166,
	"./zh-tw.js": 166
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 292;

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(331),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(335),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(275)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(341),
  /* scopeId */
  "data-v-796972dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(283)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(349),
  /* scopeId */
  "data-v-b705fc4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(282)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(348),
  /* scopeId */
  "data-v-b6e9cd4c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(281)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(347),
  /* scopeId */
  "data-v-b6cd9e4a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(277)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(343),
  /* scopeId */
  "data-v-8363dda4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(260)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(325),
  /* scopeId */
  "data-v-0b2a5c9e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(338),
  /* scopeId */
  "data-v-598e385b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(264)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(329),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(289)
__webpack_require__(288)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  "data-v-e6e8af28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(287)
__webpack_require__(286)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(351),
  /* scopeId */
  "data-v-e6cc8026",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(285)
__webpack_require__(284)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  "data-v-e6b05124",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(276)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(342),
  /* scopeId */
  "data-v-7df6ebe2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(267)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(333),
  /* scopeId */
  "data-v-43708773",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(332),
  /* scopeId */
  "data-v-40dcd8e5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(263)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(328),
  /* scopeId */
  "data-v-2ac17ef5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(278)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(344),
  /* scopeId */
  "data-v-87292ea4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(279)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(345),
  /* scopeId */
  "data-v-b4af023c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(265)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(330),
  /* scopeId */
  "data-v-3075a358",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(274)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(340),
  /* scopeId */
  "data-v-6fd68b6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(268)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(334),
  /* scopeId */
  "data-v-45a3d86f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(337),
  /* scopeId */
  "data-v-51d607ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(269)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(336),
  /* scopeId */
  "data-v-50284667",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(280)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(346),
  /* scopeId */
  "data-v-b57448a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(262)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(327),
  /* scopeId */
  "data-v-219e9300",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(259)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(324),
  /* scopeId */
  "data-v-059886c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(272)
__webpack_require__(273)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(339),
  /* scopeId */
  "data-v-5b98b6cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.imgArr), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.src
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backend-container"
  }, [_c('div', {
    staticClass: "desktop-container"
  }, [_c('div', {
    staticClass: "block-60"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "left-container"
  }, [_c('div', {
    staticClass: "developer-container"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": '/static/img' + _vm.developer.header,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.clickMenu(8)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "developer-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.developer.name))]), _vm._v(" "), _c('div', {
    staticClass: "phone-container"
  }, [_c('div', {
    staticClass: "phone-no"
  }, [_vm._v(_vm._s(_vm.developer.mobile))]), _vm._v(" "), _c('div', {
    staticClass: "quit",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menus"
  }, _vm._l((_vm.menus), function(item) {
    return _c('div', {
      key: item.label,
      staticClass: "menu",
      class: item.active ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.menuClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "iconfont",
      class: item.icon
    }), _vm._v(" "), _c('div', {
      staticClass: "menu-label"
    }, [_vm._v(_vm._s(item.label))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right-container"
  }, [_c('div', [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("开放平台")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), (_vm.breadcrumb) ? _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.breadcrumb))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right-main"
  }, [_c('router-view', {
    on: {
      "jump": _vm.jump,
      "clickMenu": _vm.clickMenu,
      "changeHeader": _vm.changeHeader,
      "changeName": _vm.changeName
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    ref: "header",
    attrs: {
      "name": "topHeader"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "swipe"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "swipeList"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "homePage0"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "homePage1"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "homePage2"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "aps"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "ac1"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "ac2"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "ac3"
    }
  }), _vm._v(" "), _c('router-view', {
    ref: "openapi",
    attrs: {
      "name": "open"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "shareContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "aboutContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "downloadContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "jobContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "login"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "backend"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "simpleFooter"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearFloat"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cooperation_banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("服务商火热招募中\n\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t领跑云打印行业，用智能让您一应俱全\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-primary",
    attrs: {
      "href": "javascript:void(0);",
      "role": "button",
      "data-toggle": "modal"
    }
  }, [_vm._v("成为代理商")])]), _vm._v(" "), _c('div', {
    staticClass: "coopti2_bg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0.8s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0.8s"
    }
  }, [_c('p', {
    staticClass: "tit_h1"
  }, [_vm._v("\n\t\t\t\t\t\t低门槛\n\t\t\t\t\t\t"), _c('span', [_vm._v("+")]), _vm._v("小投入\n\t\t\t\t\t\t"), _c('span', [_vm._v("+")]), _vm._v("大市场\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', [_vm._v("只要您愿意与我们共同发展")]), _vm._v(" "), _c('span', [_vm._v("成为代理商")]), _vm._v(" "), _c('span', [_vm._v("百亿级蓝海市场")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "npagePage cooperation"
  }, [_c('div', {
    staticClass: "cooperation_page3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('h3', {
    staticClass: "header_title wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("我们的优势")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "margin-right": "-30px",
      "margin-left": "-30px",
      "margin-top": "50px",
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "col-xs-12 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0s"
    }
  }, [_c('div', {
    staticClass: "clearfix thumbnail_cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("市场领先优势")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("众联云科技是国内最早的云打印服务提供商之一，客户遍布全国各地。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0.3s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0.3s"
    }
  }, [_c('div', {
    staticClass: "clearfix thumbnail_cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("服务优势")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cooperation_page3_img1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tc"
  }, [_c('br'), _vm._v("厂家官方统一售后，快速响应，专业售后，代理无后顾之忧。\n\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0.6s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0.6s"
    }
  }, [_c('div', {
    staticClass: "clearfix thumbnail_cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品优势")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("无需电脑、无需手机、无需驱动、无需人工，全自动接单。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("美团、饿了么、饿百多店铺全部自动接单。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("三重技术保障，彻底杜绝漏单。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "caption_div"
  }, [_c('p', [_vm._v("一重保障：断电自动重打，防止因断电导致的漏单;")]), _vm._v(" "), _c('p', [_vm._v("二重保障：掉线自动换网，防止因设备掉线导致的漏单;")]), _vm._v(" "), _c('p', [_vm._v("三重保障：真人语音提醒，防止因人为原因导致的漏单。")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v("高速打印头加自动切刀，高峰时段轻松应对。\n\t\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-delay": "0.9s",
      "animation-name": "fadeInUp"
    },
    attrs: {
      "data-wow-delay": "0.9s"
    }
  }, [_c('div', {
    staticClass: "clearfix thumbnail_cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("众联云品牌优势")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row advantage"
  }, [_c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon1"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("市场优势")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("众联云科技是最早的外卖小票云打印服务提供商之一，客户遍布全国各地。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("技术领先")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("软件、硬件均自主研发，坐享珠三角完整产业链支撑，确保技术持续领先市场。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon3"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("品质可靠")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("自主工厂生产，12道工序严格检验，通过3C认证，质量可靠。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon4"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("服务高效")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("专业售后，7*24快速响应。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-my-20"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "page3_icon icon5"
  }), _vm._v(" "), _c('div', {
    staticClass: "tit tc"
  }, [_vm._v("云端稳定")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("采用腾讯云服务器，经过五年市场考验，性能稳定。")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cooperation_page4"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('h3', {
    staticClass: "header_title wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("代理政策")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row mt30"
  }, [_c('div', {
    staticClass: "tit wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t代理商应具备资源")]), _vm._v(" "), _c('div', {
    staticClass: "page4_img wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cooppage4_img1.png",
      "alt": "自动接单打印机"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tit wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t众联云厂家给予八大支持")]), _vm._v(" "), _c('div', {
    staticClass: "page4_img page4_img2 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp",
      "margin": "50px 120px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cooppage4_img2.png",
      "alt": "自动接单打印机"
    }
  })])])])])])])
}]}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-container"
  }, [_c('div', {
    staticClass: "main-info"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": '/static/img' + _vm.developer.header,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-block",
    on: {
      "click": _vm.showHeaders
    }
  }, [_vm._v("修改头像")])]), _vm._v(" "), _c('div', {
    staticClass: "info-container"
  }, [_c('div', {
    staticClass: "info-half"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("亲，这是您第 "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.loginTimes))]), _vm._v(" 次登录管理后台，")], 1), _vm._v(" "), _c('div', {
    staticClass: "offical-link",
    on: {
      "click": _vm.gotoLog
    }
  }, [_vm._v("查看登录日志")])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("用户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.developer.name))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("注册时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.developer.createTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "info-half"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("登录账号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.developer.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("AppId：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.developer.appid))]), _vm._v(" "), _c('div', {
    staticClass: "iconfont icon-fuzhi",
    attrs: {
      "data-clipboard-text": _vm.developer.appid
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("Secret：")]), _vm._v(" "), (_vm.showSecret) ? _c('div', [_vm._v(_vm._s(_vm.developer.appSecret))]) : _c('div', [_vm._v(_vm._s(_vm.developer.appSecretDot))]), _vm._v(" "), _c('div', {
    staticClass: "iconfont icon-fuzhi",
    attrs: {
      "data-clipboard-text": _vm.developer.appSecret
    }
  }), _vm._v(" "), (_vm.showSecret) ? _c('div', {
    staticClass: "eye iconfont icon-guan",
    on: {
      "click": _vm.changeShowSecret
    }
  }) : _c('div', {
    staticClass: "eye iconfont icon-kai",
    on: {
      "click": _vm.changeShowSecret
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "edit-info"
  }, [_c('div', {
    staticClass: "edit-half"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "edit-content"
  }, [_c('el-form', {
    ref: "infoForm",
    attrs: {
      "model": _vm.developer,
      "rules": _vm.infoRule,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名称：",
      "prop": "name",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    model: {
      value: (_vm.developer.name),
      callback: function($$v) {
        _vm.$set(_vm.developer, "name", $$v)
      },
      expression: "developer.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司名称：",
      "prop": "companyName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "32"
    },
    model: {
      value: (_vm.developer.companyName),
      callback: function($$v) {
        _vm.$set(_vm.developer, "companyName", $$v)
      },
      expression: "developer.companyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系地址：",
      "prop": "address",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "64"
    },
    model: {
      value: (_vm.developer.address),
      callback: function($$v) {
        _vm.$set(_vm.developer, "address", $$v)
      },
      expression: "developer.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存修改")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "edit-half"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "edit-content"
  }, [_c('el-form', {
    ref: "pwdForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.pwdRule,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码：",
      "prop": "oldPassword",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": "32"
    },
    model: {
      value: (_vm.form.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.form, "oldPassword", $$v)
      },
      expression: "form.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码：",
      "prop": "newPassword",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": "32"
    },
    model: {
      value: (_vm.form.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.form, "newPassword", $$v)
      },
      expression: "form.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码：",
      "prop": "confirmPassword",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": "32"
    },
    model: {
      value: (_vm.form.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.form, "confirmPassword", $$v)
      },
      expression: "form.confirmPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("确认修改")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改头像",
      "visible": _vm.dialogVisible,
      "before-close": _vm.beforeClose,
      "width": "580px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "choose-container"
  }, [_c('div', {
    staticClass: "all-headers"
  }, [_c('div', _vm._l((_vm.headers1), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "tochoose-header",
      attrs: {
        "src": '/static/img/headers/' + item,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.chooseHeader(item)
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "headers2"
  }, _vm._l((_vm.headers2), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "tochoose-header",
      attrs: {
        "src": '/static/img/headers/' + item,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.chooseHeader(item)
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "preview-container"
  }, [_c('img', {
    staticClass: "preview-header",
    attrs: {
      "src": '/static/img' + _vm.currHeader,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-label"
  }, [_vm._v("头像预览")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-30"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.beforeClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeHeader
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-title"
  }, [_c('div', {
    staticClass: "iconfont icon-yonghu"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-label"
  }, [_vm._v("修改基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-title"
  }, [_c('div', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-label"
  }, [_vm._v("修改登录密码")])])
}]}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "company"
  }, [_c('div', [_vm._v("Copyright © 2021 Zonelink All Rights Reserved.")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#a3a3a3"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备2021134867号")]), _vm._v(" "), _c('a', {
    staticClass: "gongan-div",
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602009867",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.gongan
    }
  }), _vm._v(" "), _c('p', [_vm._v("粤公网安备 44010602009867号")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-kefu"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("H7 * 12 客服服务")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-zhuanye"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("T10+ 专业团队")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-anquan"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("L2+ 数据安全保护")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-xinhao"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("S4+ 信号加密")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-wending"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("D365+ 稳定不宕机")])])])])
}]}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log-container"
  }, [_c('div', {
    staticClass: "condition-container"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParams
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.$dateQuickPickerOptions
    },
    model: {
      value: (_vm.rangeTime),
      callback: function($$v) {
        _vm.rangeTime = $$v
      },
      expression: "rangeTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.query(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ip",
      "label": "IP地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "真实地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "password",
      "label": "登录密码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "登录时间"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "paging-container paging"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-sizes": _vm.$pageSizes,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callback-container"
  }, [_c('div', {
    staticClass: "top-tips"
  }, [_c('p', [_vm._v("\n            （1）根据实际的使用需要，设置相应的回调地址，只支持https（例：https://xx.zonelink.com 或 https://xx.zonelink.com/xx），不支持http、IP地址、端口号及短链域名。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            （2）填写的域名须通过ICP备案的验证。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            （3）若不使用回调删除对应的回调地址即可。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            （4）需要打印结果回调时调用打印接口时需附加设置好的回调地址参数backurl，详见 "), _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.gotoDoc
    }
  }, [_vm._v("开发文档")]), _vm._v(" 。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            （5）"), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("【重要】回调地址必须提供一个")]), _vm._v(" "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("GET")]), _vm._v(" "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("方法，返回")]), _vm._v(" "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("ZONELINK-SUCCESS")]), _vm._v(" "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("用于云服务器检测接口是否可用")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "callback-form"
  }, [_c('el-form', {
    ref: "callbackForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rule,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "回调地址：",
      "prop": "backUrl",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入打印结果回调地址（只支持https）"
    },
    model: {
      value: (_vm.form.backUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "backUrl", $$v)
      },
      expression: "form.backUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.saveCallbackUrl
    }
  }, [_vm._v("保存地址")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.reloadCallbackUrl
    }
  }, [_vm._v("重新加载")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.deleteCallbackUrl
    }
  }, [_vm._v("删除地址")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/login_img.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [(_vm.handleType == 0 || _vm.handleType == 1) ? _c('div', [_c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "name-pwd",
    class: _vm.handleType == 0 ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.changeHandleType(0)
      }
    }
  }, [_vm._v("用户登录")]), _vm._v(" "), _c('div', {
    staticClass: "register",
    class: _vm.handleType == 1 ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.changeHandleType(1)
      }
    }
  }, [_vm._v("用户注册")])]), _vm._v(" "), (_vm.handleType == 0) ? _c('div', [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone) ? _c('div', {
    staticClass: "close-btn iconfont icon-guanbi",
    on: {
      "click": _vm.cleanPhone
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [((_vm.showPwd ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwd) ? _vm._i(_vm.pwd, null) > -1 : (_vm.pwd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pwd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pwd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.pwd = $$c
        }
      }
    }
  }) : ((_vm.showPwd ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwd, null)
    },
    on: {
      "change": function($event) {
        _vm.pwd = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": _vm.showPwd ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "eye iconfont",
    class: _vm.showPwd ? 'icon-kai' : 'icon-guan',
    on: {
      "click": _vm.toggleEye
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "handle-btn",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('div', {
    staticClass: "ex"
  }, [_c('div', {
    staticClass: "error-info"
  }, [_vm._v(_vm._s(_vm.errMsg))]), _vm._v(" "), _c('div', {
    staticClass: "forget",
    on: {
      "click": function($event) {
        return _vm.changeHandleType(2)
      }
    }
  }, [_vm._v("忘记密码")])])]) : (_vm.handleType == 1) ? _c('div', [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "placeholder": "请输入用户名称"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.username) ? _c('div', {
    staticClass: "close-btn iconfont icon-guanbi",
    on: {
      "click": _vm.cleanUsername
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone) ? _c('div', {
    staticClass: "close-btn iconfont icon-guanbi",
    on: {
      "click": _vm.cleanPhone
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [((_vm.showPwd ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码（长度>=6）",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwd) ? _vm._i(_vm.pwd, null) > -1 : (_vm.pwd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pwd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pwd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.pwd = $$c
        }
      }
    }
  }) : ((_vm.showPwd ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码（长度>=6）",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwd, null)
    },
    on: {
      "change": function($event) {
        _vm.pwd = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码（长度>=6）",
      "type": _vm.showPwd ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "eye iconfont",
    class: _vm.showPwd ? 'icon-kai' : 'icon-guan',
    on: {
      "click": _vm.toggleEye
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    staticClass: "input pwd",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "captcha-code",
    on: {
      "click": _vm.getCaptchaCode
    }
  }, [(_vm.timeLeft == 0) ? _c('div', [_vm._v("获取验证码")]) : _c('div', [_vm._v("还剩 " + _vm._s(_vm.timeLeft) + " 秒")])])])]), _vm._v(" "), _c('div', {
    staticClass: "handle-btn",
    on: {
      "click": _vm.register
    }
  }, [_vm._v("注 册")]), _vm._v(" "), _c('div', {
    staticClass: "ex"
  }, [_c('div', {
    staticClass: "error-info"
  }, [_vm._v(_vm._s(_vm.errMsg))]), _vm._v(" "), _c('div', {
    staticClass: "forget",
    on: {
      "click": function($event) {
        return _vm.changeHandleType(2)
      }
    }
  }, [_vm._v("忘记密码")])])]) : _vm._e()]) : _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone) ? _c('div', {
    staticClass: "close-btn iconfont icon-guanbi",
    on: {
      "click": _vm.cleanPhone
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [((_vm.showPwd ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwd) ? _vm._i(_vm.pwd, null) > -1 : (_vm.pwd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pwd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pwd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.pwd = $$c
        }
      }
    }
  }) : ((_vm.showPwd ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwd, null)
    },
    on: {
      "change": function($event) {
        _vm.pwd = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input pwd",
    attrs: {
      "maxlength": "32",
      "placeholder": "请输入密码",
      "type": _vm.showPwd ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "eye iconfont",
    class: _vm.showPwd ? 'icon-kai' : 'icon-guan',
    on: {
      "click": _vm.toggleEye
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    staticClass: "input pwd",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "captcha-code",
    on: {
      "click": _vm.getCaptchaCode
    }
  }, [(_vm.timeLeft == 0) ? _c('div', [_vm._v("获取验证码")]) : _c('div', [_vm._v("还剩 " + _vm._s(_vm.timeLeft) + " 秒")])])])]), _vm._v(" "), _c('div', {
    staticClass: "handle-btn",
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("修 改")]), _vm._v(" "), _c('div', {
    staticClass: "ex"
  }, [_c('div', {
    staticClass: "error-info"
  }, [_vm._v(_vm._s(_vm.errMsg))]), _vm._v(" "), _c('div', {
    staticClass: "forget",
    on: {
      "click": function($event) {
        return _vm.changeHandleType(0)
      }
    }
  }, [_vm._v("用户登录")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "active"
  }, [_vm._v("找回密码")])])
}]}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test-container"
  }, [_c('div', {
    staticClass: "left-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-main"
  }, [_c('el-form', {
    ref: "printTestForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rule,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备编号：",
      "prop": "imei",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入打印设备编号(SN)"
    },
    model: {
      value: (_vm.form.imei),
      callback: function($$v) {
        _vm.$set(_vm.form, "imei", $$v)
      },
      expression: "form.imei"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单编号："
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 64,
      "placeholder": "选填，可输入订单编号，长度不能超过64"
    },
    model: {
      value: (_vm.form.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderNo", $$v)
      },
      expression: "form.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "延迟打印："
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "label": "描述文字"
    },
    model: {
      value: (_vm.form.delay),
      callback: function($$v) {
        _vm.$set(_vm.form, "delay", $$v)
      },
      expression: "form.delay"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "delay-tips"
  }, [_vm._v("（选填，默认 0 表示立即打印，单位：秒）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "打印内容：",
      "prop": "content",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "2500",
      "show-word-limit": "",
      "rows": 12,
      "placeholder": "请输入打印内容，可根据右侧标签进行组合"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.handleTest
    }
  }, [_vm._v("立即提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重新填写")])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "right-container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tags-container"
  }, _vm._l((_vm.$printTags), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tags"
    }, [_c('div', {
      staticClass: "tag-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "tag-tips"
    }, [_vm._v(_vm._s(item.tips))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-title"
  }, [_c('div', {
    staticClass: "iconfont icon-dayinji"
  }), _vm._v(" "), _c('div', {
    staticClass: "div-label"
  }, [_vm._v("打印测试表单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-tips"
  }, [_c('div', {
    staticClass: "top-tips-label"
  }, [_vm._v("说明：")]), _vm._v(" "), _c('div', [_vm._v("打印前请务必保证打印机正常在线，如不能成功打印，可微信咨询技术客服。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-title"
  }, [_c('div', {
    staticClass: "iconfont icon-biaoqian"
  }), _vm._v(" "), _c('div', {
    staticClass: "div-label"
  }, [_vm._v("打印标签")])])
}]}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "condition-container"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParams
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入设备编号"
    },
    model: {
      value: (_vm.queryParams.printerUsername),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "printerUsername", $$v)
      },
      expression: "queryParams.printerUsername"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入ICCID"
    },
    model: {
      value: (_vm.queryParams.iccid),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "iccid", $$v)
      },
      expression: "queryParams.iccid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择卡状态"
    },
    model: {
      value: (_vm.queryParams.simStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "simStatus", $$v)
      },
      expression: "queryParams.simStatus"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.query(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "设备类型",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("云打印机")]) : (scope.row.type == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("蓝牙云盒")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "printerUsername",
      "label": "设备编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "iccid",
      "label": "ICCID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "simExpireTime",
      "label": "到期时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.simStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("正常")]) : (scope.row.simStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("即将到期")]) : (scope.row.simStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已过期")]) : _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showForm(scope.row)
            }
          }
        }, [_vm._v("充值\n                    ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "paging-container paging"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-sizes": _vm.$pageSizes,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printer-container"
  }, [_c('div', {
    staticClass: "condition-container"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParams
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入设备编号"
    },
    model: {
      value: (_vm.queryParams.imei),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "imei", $$v)
      },
      expression: "queryParams.imei"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入设备名称"
    },
    model: {
      value: (_vm.queryParams.printerName),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "printerName", $$v)
      },
      expression: "queryParams.printerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择设备是否在线"
    },
    model: {
      value: (_vm.queryParams.online),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "online", $$v)
      },
      expression: "queryParams.online"
    }
  }, _vm._l((_vm.onlineOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择设备状态"
    },
    model: {
      value: (_vm.queryParams.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "status", $$v)
      },
      expression: "queryParams.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.query(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.showForm()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "设备类型",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("云打印机")]) : (scope.row.type == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("蓝牙云盒")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imei",
      "label": "编号(SN)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "账号秘钥"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.printerUsername))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(scope.row.printerPassword))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "printerName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否在线",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.dataflow == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("云对云")]) : (scope.row.online == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("在线")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("离线")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.dataflow == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("云对云")]) : (scope.row.online == 1 && scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("正常")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("异常")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "toPrintTaskCount",
      "label": "待打印",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "374"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": _vm.handleRefresh
          }
        }, [_c('i', {
          staticClass: "el-icon-refresh"
        })]), _vm._v(" "), _c('el-dropdown', {
          staticStyle: {
            "margin-left": "10px",
            "margin-right": "10px"
          },
          attrs: {
            "size": "mini",
            "split-button": "",
            "type": "primary",
            "trigger": "click"
          },
          on: {
            "visible-change": function($event) {
              return _vm.setCurrPrinter(scope.row)
            },
            "command": _vm.handleCommand
          }
        }, [_vm._v("\n                        测试\n                        "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": "text"
          }
        }, [_vm._v("普通文字")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "textCut"
          }
        }, [_vm._v("普通文字(切纸)")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "newOrder",
            "divided": ""
          }
        }, [_vm._v("新订单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "realOrder",
            "divided": ""
          }
        }, [_vm._v("完整订单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "realOrderCut",
            "divided": ""
          }
        }, [_vm._v("完整订单(切纸)")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "hurryOrder",
            "divided": ""
          }
        }, [_vm._v("催单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "cancelOrderApply",
            "divided": ""
          }
        }, [_vm._v("申请取消订单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "cancelOrder",
            "divided": ""
          }
        }, [_vm._v("订单已取消")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "refundOrder",
            "divided": ""
          }
        }, [_vm._v("订单已退款")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "advanceOrder",
            "divided": ""
          }
        }, [_vm._v("待处理预约单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "newNotice",
            "divided": ""
          }
        }, [_vm._v("新的提醒消息")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "517",
            "divided": ""
          }
        }, [_vm._v("517LOGO")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "HP",
            "divided": ""
          }
        }, [_vm._v("好评LOGO")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "JD",
            "divided": ""
          }
        }, [_vm._v("京东LOGO")])], 1)], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showForm(scope.row)
            }
          }
        }, [_vm._v("编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning",
            "disabled": scope.row.toPrintTaskCount == 0
          },
          on: {
            "click": function($event) {
              return _vm.handleClear(scope.row)
            }
          }
        }, [_vm._v("清空\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row.id)
            }
          }
        }, [_vm._v("删除\n                    ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "paging-container paging"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-sizes": _vm.$pageSizes,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "before-close": _vm.handleClose,
      "width": "480px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "infoForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "60px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编号",
      "prop": "imei"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.form.id ? true : false
    },
    model: {
      value: (_vm.form.imei),
      callback: function($$v) {
        _vm.$set(_vm.form, "imei", $$v)
      },
      expression: "form.imei"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "printerName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "256"
    },
    model: {
      value: (_vm.form.printerName),
      callback: function($$v) {
        _vm.$set(_vm.form, "printerName", $$v)
      },
      expression: "form.printerName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sitecontent"
  }, [_c('div', {
    staticClass: "contact_banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row cont"
  }, [_c('h1', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t专注提供云打印解决方案与服务")]), _vm._v(" "), _c('p', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t为客户提供可靠、持续的服务，让每个创造价值")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "npagePage contact"
  }, [_c('div', {
    staticClass: "intro_cont"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "intro_tab-content tab-content"
  }, [_c('div', {
    staticClass: "tab-pane_na"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('h3', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("联系我们")])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact_cont wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "col-xs-4 bri"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/contact_icon1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("公司地址")]), _vm._v(" "), _c('p', [_vm._v("广州市天河区珠村大粒沙路38号4栋")])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-4 bri"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/contact_icon2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("公司电话")]), _vm._v(" "), _c('p', [_vm._v("13600093009")])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-4"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/contact_icon3.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:server@zonelink.cc"
    }
  }, [_vm._v("server@zonelink.cc")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact_cont2"
  }, [_c('ul', [_c('li', {
    staticClass: "col-xs-3 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h4', [_vm._v("销售经理")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系人：")]), _vm._v("梁经理\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话：")]), _vm._v("15017026610\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("微信号：")]), _vm._v("wxid_q9y4xtv1a25d21\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("邮箱：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:sell@zonelink.cc"
    }
  }, [_vm._v("sell@zonelink.cc")])])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-3 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h4', [_vm._v("售后客服")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系人：")]), _vm._v("胡先生\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话：")]), _vm._v("13696988194\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("微信号：")]), _vm._v("hutuyang_2005\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("邮箱：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:service@zonelink.cc"
    }
  }, [_vm._v("service@zonelink.cc")])])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-3 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h4', [_vm._v("市场合作")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系人：")]), _vm._v("马先生\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话：")]), _vm._v("18688777685\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("微信号：")]), _vm._v("maliang_311\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("邮箱：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:market@zonelink.cc"
    }
  }, [_vm._v("market@zonelink.cc")])])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-3 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h4', [_vm._v("技术支持")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系：")]), _vm._v("蔡先生\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话：")]), _vm._v("18138794144")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("微信：")]), _vm._v("WDM-18138794144\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("邮箱：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:tech@zonelink.cc"
    }
  }, [_vm._v("tech@zonelink.cc")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row"
  }, [_c('h3', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("公司简介")])])]), _vm._v(" "), _c('div', {
    staticClass: "row about_cont wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "about_cont"
  }, [_c('p', [_vm._v("众联云是一家创新型技术性公司，为企业提供云打印解决方案相关产品的研发和服务，拥有强大的技术研发团队和全面的综合服务体系。")]), _vm._v(" "), _c('p', [_vm._v("众联云管理平台由广州众联云技术有限公司开发，本公司是一家专注物联网解决方案的高新科技公司，我们在万物互联的时代趋势推动下，紧跟潮流，运用最新科技成果，研发各类处于行业领先水平的智能终端，致力于满足客户的多样化需求，降低经营成本，提高生产效率。通过众联云数据处理中心的数据聚合能力，结合稳定高效的4G/5G通讯技术，实现24小时全天候不漏单智能打印，无需手机，无需电脑，无需人工参与。众联云打印机支持多店铺绑定，来单真人语音提醒，催单提醒，退款申请提醒，个性化定制小票等功能，感谢您的支持和使用。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("多年来，众联云致力于整合企业云打印服务，秉承“创新、求实、诚信、拼搏”的企业精神，为各行业商家提供全方位的打印研发、帮助餐饮商家自动接收，自动打印平台订单，提高了商家处理订单的效率，真正实现应用智能化，提升商家在网络经济市场的竞争力。以客户为中心，以技术为基础，以质量求生存，以诚信求发展，专业、专注为客户提供一个立体化的云打印解决方案。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])])])])])])])
}]}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container header"
  }, [_c('div', {
    staticClass: "col",
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/",
      "tag": "div"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "125px",
      "height": "72px"
    },
    attrs: {
      "src": "/static/img/logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('ul', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "mouseover": function($event) {
          return _vm.addClass($event)
        },
        "mouseleave": function($event) {
          return _vm.rmClass($event)
        },
        "click": function($event) {
          return _vm.toLink(item.link, $event)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.text) + "\n                        "), (index == 2) ? _c('div', {
      staticClass: "dropdown-menu"
    }, [_c('div', {
      staticClass: "dropdown-menu-item",
      on: {
        "click": function($event) {
          return _vm.jump('/ac1')
        }
      }
    }, [_vm._v("4G打印机")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu-item",
      on: {
        "click": function($event) {
          return _vm.jump('/ac2')
        }
      }
    }, [_vm._v("WiFi+USB")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu-item",
      on: {
        "click": function($event) {
          return _vm.jump('/ac3')
        }
      }
    }, [_vm._v("蓝牙+USB")]), _vm._v(" "), (index == 2) ? _c('div', {
      staticClass: "dropdown-menu-item"
    }) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.gotoBackend($event)
      }
    }
  }, [_c('div', {
    staticClass: "navbar-button"
  }, [_vm._v("管理后台")])])], 2)])], 1)]), _vm._v(" "), (_vm.showService) ? _c('div', {
    staticClass: "cndns-right"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cndns-right-meau meau-top",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "top-back"
    }
  }, [_c('a', {
    staticClass: "cndns-right-btn backtop",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.topBack()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "35px"
    }
  }, [_vm._v("^")]), _vm._v(" "), _c('i', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("顶部")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cndns-right-meau meau-sev"
  }, [_c('a', {
    staticClass: "cndns-right-btn",
    attrs: {
      "href": "javascript:"
    }
  }, [_c('span', {
    staticClass: "demo-icon"
  }), _vm._v(" "), _c('p', [_vm._v("\n                    在线\n                    "), _c('br'), _vm._v("客服\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "cndns-right-box"
  }, [_c('div', {
    staticClass: "box-border"
  }, [_c('div', {
    staticClass: "clearfix sev-t"
  }, [_c('span', {
    staticClass: "demo-icon"
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  })]), _vm._v(" "), _c('p', [_vm._v("\n                            在线客服\n                            "), _c('i', [_vm._v("服务时间：周一至周日 09:00～20:00")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix sev-b"
  }, [_c('h4', [_vm._v("选择下列服务马上在线沟通：")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "zixunUl"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "tencent://message/?uin=9892500&Site=&Menu=yes"
    }
  }, [_vm._v("销售经理")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "tencent://message/?uin=9892500&Site=&Menu=yes"
    }
  }, [_vm._v("市场合作")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "tencent://message/?uin=9892500&Site=&Menu=yes"
    }
  }, [_vm._v("技术支持")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "tencent://message/?uin=9892500&Site=&Menu=yes"
    }
  }, [_vm._v("售后客服")])])])]), _vm._v(" "), _c('span', {
    staticClass: "arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cndns-right-meau meau-contact"
  }, [_c('a', {
    staticClass: "cndns-right-btn",
    attrs: {
      "href": "javascript:"
    }
  }, [_c('span', {
    staticClass: "demo-icon t2"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/t2.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                    客服\n                    "), _c('br'), _vm._v("热线\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "cndns-right-box"
  }, [_c('div', {
    staticClass: "box-border"
  }, [_c('div', {
    staticClass: "clearfix sev-t"
  }, [_c('p', [_vm._v("\n                            13600093009\n                            "), _c('br'), _vm._v(" "), _c('i', [_vm._v("服务时间：周一至周日 09:00～20:00")])])]), _vm._v(" "), _c('span', {
    staticClass: "arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cndns-right-meau meau-code"
  }, [_c('a', {
    staticClass: "cndns-right-btn",
    attrs: {
      "href": "javascript:"
    }
  }, [_c('span', {
    staticClass: "demo-icon t3"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/t3.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                    关注\n                    "), _c('br'), _vm._v("微信\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "cndns-right-box"
  }, [_c('div', {
    staticClass: "box-border clearfix"
  }, [_c('div', {
    staticClass: "sev-t"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/wx.jpg"
    }
  }), _vm._v(" "), _c('i', [_vm._v("关注微信公众号")])]), _vm._v(" "), _c('span', {
    staticClass: "arrow-right"
  })])])])
}]}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "condition-container"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParams
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入设备编号"
    },
    model: {
      value: (_vm.queryParams.clientUsername),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "clientUsername", $$v)
      },
      expression: "queryParams.clientUsername"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入订单编号"
    },
    model: {
      value: (_vm.queryParams.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "orderNo", $$v)
      },
      expression: "queryParams.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.$dateQuickPickerOptions
    },
    model: {
      value: (_vm.rangeTime),
      callback: function($$v) {
        _vm.rangeTime = $$v
      },
      expression: "rangeTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.query(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imei",
      "label": "设备编号(SN)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "打印诉求",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.delay == 0) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("立即打印")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("延迟" + _vm._s(scope.row.delay) + "分钟打印")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "回调需求",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.needCallback == 1) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("需要")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("不需要")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "打印内容",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "detail",
          on: {
            "click": function($event) {
              return _vm.detail(scope.row)
            }
          }
        }, [_vm._v("点击查看")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "任务状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已取消")]) : (!scope.row.printResult) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("待处理")]) : (scope.row.printResult == 1) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("已下发")]) : (scope.row.printResult == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("已接收")]) : (scope.row.printResult == 3) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已完成")]) : (scope.row.printResult == 4 || scope.row.printResult == 5) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("待重推\n                    ")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "completeTime",
      "label": "完成时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "costTime",
      "label": "耗时(s)",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "148"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.reprint(scope.row.id)
            }
          }
        }, [_vm._v("重打\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "disabled": scope.row.status == 1 || scope.row.printResult == 3
          },
          on: {
            "click": function($event) {
              return _vm.setComplete(scope.row)
            }
          }
        }, [_vm._v("取消\n                    ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "paging-container paging"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-sizes": _vm.$pageSizes,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "打印内容",
      "visible": _vm.detailVisible,
      "close-on-click-modal": false,
      "width": "640px"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "task-content"
  }, [_vm._v(_vm._s(_vm.taskContent))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "id": "copy",
      "data-clipboard-text": _vm.taskContent
    }
  }, [_vm._v("复 制")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关 闭")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix npagePage product",
    staticStyle: {
      "margin-bottom": "-15px"
    }
  }, [_c('div', {
    staticClass: "product_list"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "col-xs-12 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clickEvent('/ac1')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/4gimg.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clickEvent('/ac2')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/wifiimg.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clickEvent('/ac3')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/bluetoothImg.jpg"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pde"
  })])
},staticRenderFns: []}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("直接跳转到后台页面")])
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aps"
  }, [_c('div', {
    staticClass: "sitecontent"
  }, [_c('div', {
    staticClass: "inr_banner"
  })]), _vm._v(" "), _c('div', {
    staticClass: "npagePage introduction"
  }, [_c('div', {
    staticClass: "intro_cont"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "intro_tab-content tab-content"
  }, [_c('div', {
    staticClass: "intro_panel-01"
  }, [_c('div', {
    staticClass: "tab-pane_na wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("面向普通外卖商户")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "clearfix text_cont"
  }, [_c('img', {
    staticClass: "fl",
    attrs: {
      "src": "/static/img/appimg1.jpg",
      "alt": "自动接单打印机"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text_div text1 fl text_fr"
  }, [_c('p', [_vm._v("众联云打印机提供众联云助手，商户购买打印机后，轻松即可绑定店铺。")]), _vm._v(" "), _c('p', [_vm._v("支持以下平台：")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/static/img/appimg3.jpg",
      "alt": "平台外卖接单"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane_na mt20"
  }, [_c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h3', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("面向软件开发商")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "clearfix text_cont wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    staticClass: "fl",
    attrs: {
      "src": "/static/img/appimg2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text_div text3 fl text_fr"
  }, [_c('p', [_c('span', [_vm._v("1")]), _vm._v("众联云开放平台对外开放API接口，给开发人员带来了极大的方便，只需30分钟即可完成对接，API接口支持PHP、Java、NodeJS等语言;\n                                            ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("2")]), _vm._v("软件开发商对接打印机时，免费给客户提供技术支持;\n                                            ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("3")]), _vm._v("打印机可自定义打印内容和格式，支持二维码、条形码、LOGO打印等；\n                                            ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("4")]), _vm._v("提供网页版开发者中心，轻松管理订单与机器。\n                                            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane_na mt20"
  }, [_c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h3', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("场景案例展示")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "clearfix text_cont"
  }, [_c('div', {
    staticClass: "text_div text4 fl text_fr"
  }, [_c('p', {
    staticClass: "img tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/animg1.jpg",
      "alt": "餐饮打印机小票"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ti tc"
  }, [_vm._v("餐饮店：外卖后厨小票打印")]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_vm._v("\n                                                打印机支持多种餐饮软件，一台打印机完成多个平台订单\n                                                "), _c('br'), _vm._v("无需连接电脑、手机、蓝牙，节约成本压力\n                                                "), _c('br'), _vm._v("自动接单、自动打印，真正省时省力省心\n                                                "), _c('br'), _vm._v("打印机放在前台和后厨能同时出单，更加便利高效\n                                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text_div text4 fl text_fr"
  }, [_c('p', {
    staticClass: "img tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/animg2.jpg",
      "alt": "收银台打印机小票"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ti tc"
  }, [_vm._v("收银台：超市小票打印")]), _vm._v(" "), _c('p', {
    staticClass: "cont",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v("\n                                                打印机能对接云收银系统，即插即用\n                                                "), _c('br'), _vm._v("打印机只需连接WiFi或GPRS网络，无需配备电脑，节省成本\n                                                "), _c('br'), _vm._v("自动打印订单功能，进一步提升收银效率\n                                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "clearfix text_cont",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "text_div text4 fl text_fr"
  }, [_c('p', {
    staticClass: "img tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/animg3.jpg",
      "alt": "药店打印机小票"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ti tc"
  }, [_vm._v("药店：药品小票打印")]), _vm._v(" "), _c('p', {
    staticClass: "cont",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v("\n                                                打印机是药店经营的得力帮手，使用中需要接入小票打印机\n                                                "), _c('br'), _vm._v("无需配备电脑，节省成本，提供用户销售凭证\n                                                "), _c('br'), _vm._v("自动打印订单功能，快速结账\n                                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text_div text4 fl text_fr"
  }, [_c('p', {
    staticClass: "img tc"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/animg4.jpg",
      "alt": "加油站打印机小票"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ti tc"
  }, [_vm._v("加油站：订单发票打印")]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_vm._v("\n                                                扫码加油，手机支付，自动打印小票\n                                                "), _c('br'), _vm._v("无需下车，既可完成加油，极大提高司机加油体验。\n                                            ")])])])])])])])])])])])])
}]}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "condition-container"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParams
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入订单编号"
    },
    model: {
      value: (_vm.queryParams.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "orderNo", $$v)
      },
      expression: "queryParams.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入ICCID"
    },
    model: {
      value: (_vm.queryParams.iccid),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "iccid", $$v)
      },
      expression: "queryParams.iccid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.$dateQuickPickerOptions
    },
    model: {
      value: (_vm.rangeTime),
      callback: function($$v) {
        _vm.rangeTime = $$v
      },
      expression: "rangeTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.query(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "iccid",
      "label": "ICCID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "充值时长"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.year) + " 年\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "充值金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.money) + " 元\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "充值时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "simExpireTime",
      "label": "到期时间",
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "paging-container paging"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-sizes": _vm.$pageSizes,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-container"
  }, [_c('div', {
    staticClass: "left-container"
  }, [_c('div', {
    staticClass: "index-header"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": '/static/img' + _vm.developer.header,
      "alt": ""
    },
    on: {
      "click": _vm.gotoCenter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_vm._v("亲，欢迎使用众联云打印服务")]), _vm._v(" "), _c('div', {
    staticClass: "tips-item"
  }, [_c('div', {
    staticClass: "app-info"
  }, [_c('div', {
    staticClass: "app-label"
  }, [_vm._v("Appid")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.developer.appid))])]), _vm._v(" "), _c('div', {
    staticClass: "iconfont icon-fuzhi",
    attrs: {
      "data-clipboard-text": _vm.developer.appid
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips-item"
  }, [_c('div', {
    staticClass: "app-info"
  }, [_c('div', {
    staticClass: "app-label"
  }, [_vm._v("Secret")]), _vm._v(" "), (_vm.showSecret) ? _c('div', [_vm._v(_vm._s(_vm.developer.appSecret))]) : _c('div', [_vm._v(_vm._s(_vm.developer.appSecretDot))])]), _vm._v(" "), _c('div', {
    staticClass: "iconfont icon-fuzhi",
    attrs: {
      "data-clipboard-text": _vm.developer.appSecret
    }
  }), _vm._v(" "), (_vm.showSecret) ? _c('div', {
    staticClass: "eye iconfont icon-guan",
    on: {
      "click": _vm.changeShowSecret
    }
  }) : _c('div', {
    staticClass: "eye iconfont icon-kai",
    on: {
      "click": _vm.changeShowSecret
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("亲，这是您第 "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.loginTimes))]), _vm._v(" 次登录管理后台，")], 1), _vm._v(" "), _c('div', {
    staticClass: "offical-link",
    on: {
      "click": _vm.gotoLog
    }
  }, [_vm._v("查看登录日志")])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("您已绑定 "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.printerCount))]), _vm._v(" 台设备，")], 1), _vm._v(" "), _c('div', {
    staticClass: "offical-link",
    on: {
      "click": _vm.gotoPrinter
    }
  }, [_vm._v("设备管理")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-logs"
  }, [(_vm.logList && _vm.logList[0]) ? _c('div', {
    staticClass: "login-log login-log-curr"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("IP段：" + _vm._s(_vm.logList[0].ip))]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("地址：" + _vm._s(_vm.logList[0].address))]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("\n                        时间：" + _vm._s(_vm.logList[0].createTime) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.logList && _vm.logList[1]) ? _c('div', {
    staticClass: "login-log login-log-prev"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("IP段：" + _vm._s(_vm.logList[1].ip))]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("地址：" + _vm._s(_vm.logList[1].address))]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("时间：" + _vm._s(_vm.logList[1].createTime))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "shops"
  }, _vm._l((_vm.shops), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "shop-item",
      on: {
        "click": function($event) {
          return _vm.gotoShop(item.link)
        }
      }
    }, [_c('img', {
      staticClass: "shop-logo",
      attrs: {
        "src": item.logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "shop-name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "right-container"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "news-container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('el-timeline', _vm._l((_vm.activities), function(activity, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "icon": activity.icon,
        "type": activity.type,
        "color": activity.color,
        "timestamp": activity.timestamp
      }
    }, [_vm._v("\n                        " + _vm._s(activity.content) + "\n                    ")])
  }), 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "iconfont icon-dizhi"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-tips"
  }, [_vm._v("本次登录信息：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "iconfont icon-dizhi"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-tips"
  }, [_vm._v("上次登录信息：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcodes"
  }, [_c('div', {
    staticClass: "qrcode-item"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": "/static/img/tech.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("开发问题咨询请扫描添加上方微信")])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-item"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": "/static/img/wx.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("消息通知扫描关注“众联云助手”公众号")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "iconfont icon-gonggao"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-label"
  }, [_vm._v("系统公告")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("尊敬的用户：")]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("您好！")]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("\n                    众联云打印服务是由广州众联云技术有限公司开发，本公司是一家专注物联网解决方案的高新科技公司，我们在万物互联的时代趋势推动下，紧跟潮流，运用最新科技成果，研发各类处于行业领先水平的智能终端，致力于满足客户的多样化需求，降低经营成本，提高生产效率。\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("\n                    我们的产品有云打印机、蓝牙云盒、云喇叭等，通过众联云数据中心的数据聚合能力，结合稳定高效的WiFi/4G/5G通讯技术，实现24小时全天候不漏单智能打印和语音播报，无需手机，无需电脑，无需人工参与。众联云打印机支持多店铺绑定，来单真人语音提醒，催单提醒，退款申请提醒，个性化定制小票等功能，感谢您的支持和使用。\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("众联云打印团队在此深深感谢大家长期以来的支持与厚爱，接下来我们会更加努力，给您提供更优质更全面的服务！！")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("祝商祺!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "yin-container"
  }, [_c('img', {
    staticClass: "yin",
    attrs: {
      "src": "/static/img/yin.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("\n                        众联云打印团队\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("\n                        2022年10月10日\n                    ")])]), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "iconfont icon-jiekou"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-label"
  }, [_vm._v("最新动态")])])
}]}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "open-container"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "block-60"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-tabs"
  }, [_c('div', {
    staticClass: "container tab-content"
  }, [_c('div', {
    staticClass: "row tab-pane active",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "panel-1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "opendoc_right white_bg"
  }, [_c('div', {
    staticClass: "content2_he"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "menu0 menu_tab"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("平台简介")]), _vm._v(" "), _c('p', [_vm._v("\n                                                众联云打印开放平台，为开发者提供各行业的云打印解决方案，致力于成为国内最安全、稳定的云打印服务平台。\n                                                "), _c('br'), _vm._v("平台日均打印小票超过一百万，云打印解决方案可以有效提升商家经营效率、降低经营成本、提升市场竞争力、提高消费者的服务体验。\n                                                "), _c('br'), _vm._v("众联云打印开放平台提供完善的API开发文档以及示例，还有免费的技术支持服务。\n                                                "), _c('br'), _vm._v("接入众联云打印开放平台，让你的应用马上具备云打印功能，随时随地打印，不受距离限制。\n                                                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("平台目前提供两种类型的设备支持：\n                                                "), _c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("（1）普通WiFi / 4G 打印机")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("（2）云盒，一种可以连接蓝牙设备实现云打印的外设")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "menu1 menu_tab"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab1"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n                                            开发者接入API步骤如下，如对接遇到问题，请加众联云技术支持微信咨询（请务必备注"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("“开放平台对接”")]), _vm._v("）：\n                                        ")], 1), _vm._v(" "), _c('img', {
    staticClass: "tech-qrcode",
    attrs: {
      "src": "/static/img/tech.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p'), _vm._v(" "), _c('h4', {
    staticClass: "bg-h4"
  }, [_vm._v("第一步：注册开发者账号")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "bg-h4"
  }, [_vm._v("第二步：对接API（HTTPS协议）")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb",
    staticStyle: {
      "color": "#999",
      "border-radius": "0 0 5px 5px"
    }
  }, [_vm._v("\n                                            注意:建议先调用添加设备接口，然后再调用打印接口进行打印，这样您可以在开放平台的管理后台查看打印记录。所有API接口都是"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n                                                https ")]), _vm._v("\n                                            协议。"), _c('br'), _c('br'), _vm._v("\n                                            1、 "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("【必接】")]), _vm._v("绑定设备到开发者账户\n                                        ")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "bg-h4"
  }, [_vm._v("第三步：测试打印")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb",
    staticStyle: {
      "color": "#999",
      "border-radius": "0 0 5px 5px"
    }
  }, [_vm._v("\n                                            测试打印之前，请确保设备在线，并且纸张正常。如调试打印模板有问题，请扫描上方技术支持二维码添加技术对接工作人员进行咨询。")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab3"
    }
  }, [_vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "tab_mb f14"
  }, [_vm._v("\n                                            Restful API本质就是发送 HTTP 请求，只不过大家常用的可能是 HTTP GET 和 HTTP POST 请求，但是在 Restful\n                                            API里面还经常用到\n                                            HTTP PUT 、HTTP PACTCH、 HTTP DELETE。\n                                            "), _c('br'), _vm._v("在 Restful\n                                            API中，把这五种操作称之为动词，可以（但不是特别准确）想象成增删改查。客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                            "), _c('br'), _vm._v("Restful API 接口调用成功时返回 HTTP 状态码为 200，如调用错误会返回除 200 之外的其他 HTTP\n                                            状态码，可根据返回数据中的\n                                            code和msg 字段判断具体错误。\n                                            "), _c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("常见HTTP错误状态码如下：")])], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("全局code如下：")]), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('div', {
    staticClass: "menu2 menu_tab"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-1"
    }
  }, [_vm._m(14), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/add")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("POST")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号(可查看设备侧边或底部标签)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备名称/备注")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(16)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(17), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(20)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-2"
    }
  }, [_vm._m(21), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/info")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("GET")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求URL参数：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(22), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号(可查看设备侧边或底部标签)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(23)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(24), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ id")]), _vm._v(" "), _c('td', [_vm._v("long")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备ID\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备编号\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ name")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备名称\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ type")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备类型，1：打印机，2：云盒\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ width")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        纸宽，目前只有两个规格 58 或 80\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ iccid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        流量卡号，WiFi机型该值为空\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ online")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备是否在线，1：在线，0：离线\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ status")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备自身状态，1：正常，0：异常\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ toPrintCount")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        待打印任务数，默认 0\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ cutAble")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        是否带切刀，true：带切刀，false：不带切刀\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ vocAble")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        语音播报开关，true：播报语音，false：不播报语音\n                                                    ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-3"
    }
  }, [_vm._m(28), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/setting")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("PUT")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(29), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("修改设备名称\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_c('font', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bolder"
    }
  }, [_vm._v(" 【注意】")]), _vm._v("\n                                                        修改设备纸宽，仅限设备是"), _c('font', {
    staticStyle: {
      "color": "red",
      "font-weight": "bolder"
    }
  }, [_vm._v(" 云盒\n                                                        ")]), _vm._v("的时候才生效\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("cutAble")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_c('font', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bolder"
    }
  }, [_vm._v(" 【注意】")]), _vm._v("\n                                                        修改设备是否有切刀，仅限设备是"), _c('font', {
    staticStyle: {
      "color": "red",
      "font-weight": "bolder"
    }
  }, [_vm._v(" 云盒\n                                                        ")]), _vm._v("的时候才生效\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("vocAble")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("设置是否播报语音，true：播报语音，false：不播报语音\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(30)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(31), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(34)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-4"
    }
  }, [_vm._m(35), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/delete")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("DELETE")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(36), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(37)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(38), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(39), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(41)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-5"
    }
  }, [_vm._m(42), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/task/add")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("POST")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(43), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号(查看设备侧边或底部标签)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("【重要】订单编号，开发者自有系统的订单编号，若需回调打印结果 或\n                                                        主动查询打印任务状态"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("，开发者自己保证"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n                                                            唯一\n                                                        ")]), _vm._v("性\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("content")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("打印内容，最大支持 4000 字节（中文按照2字节计算）")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("delay")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("延迟打印"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("（单位：秒）")]), _vm._v("，默认为 0，云平台接收到打印任务立即执行")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("expiredDay")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("打印任务过期时间"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("（单位：天）")]), _vm._v("，默认为\n                                                        1，N天内目标打印设备没有执行打印则任务自动丢弃\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(44)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(45), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ createTime")]), _vm._v(" "), _c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        任务接收时间\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        订单编号\n                                                    ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("小票排版控制标签说明：(详情请参考SDK示例)")])], 1), _vm._v(" "), _c('pre', {
    staticClass: "prettyprint linenums prettyprinted"
  }, [_c('ol', {
    staticClass: "linenums"
  }, _vm._l((_vm.$printTags), function(item) {
    return _c('li', {
      key: item.label
    }, [_c('span', {
      staticClass: "hljs-string"
    }, [_vm._v(" " + _vm._s(item.label) + " ")]), _vm._v("：" + _vm._s(item.tips))])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(48)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-5"
    }
  }, [_vm._m(49), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/task/delete")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("DELETE")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(50), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("打印任务订单号，"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("开发者自有系统的订单编号")]), _vm._v("，下发打印任务时传入\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(51)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(52), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])])])]), _vm._v(" "), _vm._m(53), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(55)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-6"
    }
  }, [_vm._m(56), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/task/clean")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("DELETE")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(57), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(58)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(59), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ count")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        清空的任务数\n                                                    ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(60), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(62)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-7"
    }
  }, [_vm._m(63), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/task/status")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("GET")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求URL参数：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(64), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("打印任务订单号，"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("开发者自有系统的订单编号")]), _vm._v("，下发打印任务时传入\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(65)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(66), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ status")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        打印任务状态，0：待发送至设备，1：已下发至设备，2：设备已接收，3：打印完成，4：被删除，5：延迟打印\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ delay")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        延迟打印剩余时间，当 status=5 时返回，单位：秒\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ printTime")]), _vm._v(" "), _c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        打印任务完成时间，当 status=3 时返回\n                                                    ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(67), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(69)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-8"
    }
  }, [_vm._m(70), _vm._v(" "), _c('div', {
    staticClass: "callback-container"
  }, [_c('div', [_vm._v("\n                                                【说明】此接口是云服务器主动向开发者服务器回传打印任务状态。\n                                            ")]), _vm._v(" "), _c('div', [_vm._v("\n                                                【编码】发送的数据类型为：application/json，数据编码为：UTF-8。\n                                            ")]), _vm._v(" "), _c('div', [_vm._v("\n                                                【前提】需要在开发者后台"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("配置")]), _vm._v("打印任务状态"), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("回调地址\n                                                ")]), _vm._v("\n                                                ，且调用\n                                                "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("“下发打印任务”")]), _vm._v("接口时务必传入"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("orderNo\n                                                ")]), _vm._v("。\n                                            ")], 1), _vm._v(" "), _c('div', [_vm._v("\n                                                【安全】开发者需要根据签名算法对回调地址接收到的数据做安全校验。\n                                            ")])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("POST")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求响应：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            开发者接收后需立即返回 "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("SUCCESS")]), _vm._v("\n                                            ，如5秒内不返回或返回数据格式错误，云平台会重新推送，最多重推3次。\n                                        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(71), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("long")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("开发者自有系统的订单编号，开发者自己保证"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" 唯一\n                                                        ")]), _vm._v("性\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(72)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("开发者响应返回示例：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("SUCCESS")])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-9"
    }
  }, [_vm._m(73), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("签名生成的通用步骤如下：")]), _vm._v(" "), _vm._m(74), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("特别注意以下重要规则：")]), _vm._v(" "), _vm._m(75), _vm._v(" "), _c('p', [_c('b', [_vm._v("第二步：")]), _vm._v("在 paramString 最后拼接上"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" appsecret ")]), _vm._v("\n                                            得到 signString 字符串，并对 signString 进行MD5运算，再将得到的字符串所有字符转换为大写，得到 sign 值\n                                            signValue。\n                                        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("举例：")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("假设传送的参数如下：")]), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            paramString =\n                                            \"appid=jSOrPqkMuxff&key=nBx3XNuXsnTDWSzJ&name=zonelink&sn=Hy7Imeya17id&timestamp=1664267034\";\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("第二步：拼接API密钥：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            signString = \"paramString&appsecret=WjHdVQ8n7heUUbrKDsNU8Wj5iO6rGRTq\"\n                                            "), _c('br'), _vm._v("sign = MD5(signString).toUpperCase()\n                                            "), _c('br'), _vm._v("得到最终结果："), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("F35BED40E66CF30C896ECF34D145C1E2")])], 1), _vm._v(" "), _c('p', {
    staticClass: "t_h5",
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("注意：appid 和 appsecret 的值，请登陆管理后台查看开发者信息")])])]), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opendoc_left"
  }, [_c('div', {
    staticClass: "tools-nav white_bg"
  }, [_c('div', {
    staticClass: "menu"
  }, [_c('h3', {
    staticClass: "onleft"
  }, [_vm._v("一. 平台介绍")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu0",
    staticStyle: {
      "display": "block"
    }
  }, [_c('li', [_c('a', {
    staticClass: "selected"
  }, [_vm._v("平台简介")])]), _vm._v(" "), _c('li', [_c('a', {}, [_vm._v("开放平台管理规则")])])]), _vm._v(" "), _c('h3', {}, [_vm._v("二. 开发者对接说明")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu1",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', [_c('a', {}, [_vm._v("对接步骤")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("公共参数说明")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Restful 介绍 & 全局返回码")])])]), _vm._v(" "), _c('h3', {}, [_vm._v("三. 接口列表")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu2",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', [_c('a', {}, [_vm._v("添加设备")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("获取设备信息")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("设置设备信息")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("删除设备")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("小票机下发打印任务")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("删除指定打印任务")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("清空设备待打印任务")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("查询打印任务状态")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "callback"
    }
  }, [_c('a', [_vm._v("打印成功后回调")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "qm_href"
    }
  }, [_c('a', [_vm._v("\n                                                签名生成算法\n                                            ")])])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "sdk_href"
    }
  }, [_vm._v("四. SDK 示例下载")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu4"
  }, [_c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "selected",
    attrs: {
      "href": "https://www.zonelink.cc/open/index.html#tab4-1"
    }
  }, [_vm._v("SDK\n                                                示例下载")])])]), _vm._v(" "), _c('h3', [_vm._v("五. 常见问题")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu5"
  }, [_c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "selected",
    attrs: {
      "href": "https://www.zonelink.cc/open/index.html#tab5-1"
    }
  }, [_vm._v("常见问题")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "get-menu"
  }, [_c('h4', {
    staticClass: "nav_title A1"
  }, [_vm._v("平台介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": "/static/img/process.jpg",
      "alt": "云打印流程"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("开放平台运营管理规则")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("1.相关定义")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("众联云打印开放平台")]), _vm._v("：众联云打印开放平台（以下简称“开放平台”），众联云，为第三方提供：技术文档、应用程序等相关服务，帮助其使用众联云打印服务。\n                                            ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("第三方")]), _vm._v("：指与开放平台合作的任何第三方，包括但不限于个人开发者、企业开发者、以及个人或企业开发者的关联公司、合作方。\n                                            ")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("2.开放平台接入流程")]), _vm._v(" "), _c('h5', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("接入指南")]), _vm._v(" "), _c('p', [_vm._v("第一步：注册（开发者的账号密码具有唯一性，开发者需对账号下的一切操作承担全部责任与法律后果）；")]), _vm._v(" "), _c('p', [_vm._v("第二步：阅读并确认了解《众联云打印开放平台服务条款》；")]), _vm._v(" "), _c('p', [_vm._v("第三步：完善第三方信息；")]), _vm._v(" "), _c('p', [_vm._v("第四步：根据接口文档进行开发；")]), _vm._v(" "), _c('p', [_vm._v("第五步：开发测试；")]), _vm._v(" "), _c('p', [_vm._v("第六步：上线；")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("3.免责声明")]), _vm._v(" "), _c('h5', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("条款")]), _vm._v(" "), _c('p', [_vm._v("（1）对于使用了开放平台提供服务的第三方，必须遵守法律法规，如有违反，第三方同意独立承担所有的风险和后果。")]), _vm._v(" "), _c('p', [_vm._v("（2）第三方将使用了开放平台提供服务后的系统提供给最终用户使用时，应充分告知其相关注意事项。因任何人使用第三方开发或运营的系统所产生的任何问题、事故或纠纷，均由第三方自行承担全部责任，开放平台对此不承担责任。\n                                            ")]), _vm._v(" "), _c('p', [_vm._v("（3）开放平台因本条前述事由受到损失或者被要求承担责任的，有权要求相应第三方赔偿开放平台因此受到的损失和/或要求该开发者承担相关责任。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tab_mb",
    staticStyle: {
      "color": "#999",
      "border-radius": "0 0 5px 5px"
    }
  }, [_vm._v("\n                                            到\n                                            "), _c('a', {
    staticClass: "font_0071",
    attrs: {
      "href": "/login",
      "target": "_blank"
    }
  }, [_vm._v("https://www.zonelink.cc/login")]), _vm._v("\n                                            （以下统称‘众联云开放后台’）注册开发者账号。\n                                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("请求公共参数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("返回公共参数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("Restful API 介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("HTTP 返回码（Status Code）")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("400")]), _vm._v(" "), _c('td', [_vm._v("（错误请求）服务器不理解请求的语法。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("401")]), _vm._v(" "), _c('td', [_vm._v("（未授权）请求要求身份验证。对于需要sign的接口，服务器可能返回此响应。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("403")]), _vm._v(" "), _c('td', [_vm._v("（禁止）服务器拒绝请求。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("404")]), _vm._v(" "), _c('td', [_vm._v("（未找到）服务器找不到请求的接口。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("408")]), _vm._v(" "), _c('td', [_vm._v("（请求超时）服务器等候请求时发生超时。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("413")]), _vm._v(" "), _c('td', [_vm._v("（请求体过大）拆成更小的请求体重试即可。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("500")]), _vm._v(" "), _c('td', [_vm._v("（服务器内部错误）请求参数不正确或服务器遇到错误，无法完成请求。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("501")]), _vm._v(" "), _c('td', [_vm._v("（尚未实施）服务器不具备完成请求的功能。例如，服务器无法识别请求方法时可能会返回此代码。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("502")]), _vm._v(" "), _c('td', [_vm._v("（错误网关）服务器作为网关或代理，从上游服务器收到无效响应。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("503")]), _vm._v(" "), _c('td', [_vm._v("（服务不可用）请求接口超过调用频率限制，即接口被限流。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("504")]), _vm._v(" "), _c('td', [_vm._v("（网关超时）服务器作为网关或代理，但是没有及时从上游服务器收到请求。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                                            更多 Restful API 背景知识可以参考\n                                            "), _c('a', {
    staticClass: "blue",
    attrs: {
      "href": "https://www.ruanyifeng.com/blog/2014/05/restful_api.html",
      "target": "_blank"
    }
  }, [_vm._v("Restful API 设计指南。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v("成功")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-1")]), _vm._v(" "), _c('td', [_vm._v("请求参数不正确")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-2")]), _vm._v(" "), _c('td', [_vm._v("appid不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-3")]), _vm._v(" "), _c('td', [_vm._v("签名错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-4")]), _vm._v(" "), _c('td', [_vm._v("请求超时")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10000")]), _vm._v(" "), _c('td', [_vm._v("开发者信息错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("大于0")]), _vm._v(" "), _c('td', [_vm._v("错误码大于0时每个接口返回不一样，具体请看各个接口")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("添加设备")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"ok\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备编号为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("设备KEY为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("设备名称为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("设备编号或KEY错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("此设备已添加，不能重复添加")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("系统繁忙")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("获取设备信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("0")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"ok\"")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"data\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v(" {")])])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"id\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("               "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 设备编号")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"sn\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"Hy7Imeya17id\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("  "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 设备编号")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"name\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"zonelink\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("    "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 设备名称")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"type\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("             "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 设备类型，1：打印机，2：云盒")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"width\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("58")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("           "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 纸宽，目前只有两个规格 58 和 80")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"imsi\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"xxx\"")])]), _vm._v("          "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 流量卡号码,wifi机型该值为空")])])]), _c('li', {
    staticClass: "L4"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"online\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("           "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 是否在线，1：在线：0：离线")])])]), _c('li', {
    staticClass: "L5"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"status\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("           "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 状态，1：正常，0：异常")])])]), _c('li', {
    staticClass: "L6"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"toPrintCount\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("     "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 待打印任务数")])])]), _c('li', {
    staticClass: "L7"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"cutAble\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("false")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("      "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 是否带切刀，true：带切刀，false：不带切刀")])])]), _c('li', {
    staticClass: "L8"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vocAble\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("true")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("       "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 语音播报开关，true：播报语音，false：不播报语音")])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("       ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("}")])])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("系统繁忙")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("设置设备信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"ok\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("非云盒纸宽设置无效")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("非云盒切刀设置无效")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("至少必须存在一项编辑项")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("系统繁忙")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("删除设备")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"ok\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("系统繁忙")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("小票机下发打印任务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"ok\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"data\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("{")])])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"createTime\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"2022-10-10 00:00:00\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"orderNo\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"2022101000001\"         // 如果开发者不传入，云平台会自动生成订单号，但是打印结果不会回调")])])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("}")])])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备编号SN不正确")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("打印内容为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("打印内容长度超过4000字节")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("需要回调所以客户订单号不可为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("订单号长度超过64")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("删除指定打印任务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"ok\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("暂无权限")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("清空指定设备待打印任务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v(" ")]), _c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"ok\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v(" ")]), _c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"data\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("{")])])]), _c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"count\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("10")])])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_vm._v("}")])]), _c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("暂无权限")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("查询打印任务状态")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"ok\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"data\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"status\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("3")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"printTime\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"2022-10-10 00:00:00\"")])])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("}")])])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])]), _vm._v("\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("订单号为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("查无此订单号对应的打印任务")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("延迟打印失败")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("打印成功后回调")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("第一步：")]), _vm._v("设所有发送或者接收到的数据为集合M，将集合M内非空参数值的参数按照参数名ASCII码从小到大排序（字典序），使用URL键值对的格式（即key1=value1&key2=value2…）拼接成字符串\n                                            paramString。\n                                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            ◆ 参数名ASCII码从小到大排序（字典序）；\n                                            "), _c('br'), _vm._v("◆ 如果参数的值为空不参与签名，注意为空指空字符串，\"0\"不为空字符串，需参与签名；\n                                            "), _c('br'), _vm._v("◆ 参数名区分大小写；\n                                            "), _c('br'), _vm._v("◆ 验证调用返回或微信主动通知签名时，传送的sign参数不参与签名，将生成的签名与该sign值作校验。\n                                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"appid\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"jSOrPqkMuxff\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"timestamp\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"1664267034\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"sn\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"Hy7Imeya17id\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L4"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"key\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"nBx3XNuXsnTDWSzJ\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L5"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"name\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"zonelink\"")])])])]), _c('li', {
    staticClass: "L6"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "t_h5"
  }, [_c('b', [_vm._v("第一步：")]), _vm._v("对参数按照key=value的格式，并按照参数名ASCII字典序排序如下：\n                                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu4 menu_tab"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab4-1"
    }
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/java.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-Java版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/java-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/php.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-PHP版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/php-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/nodejs.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-NodeJS版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/nodejs-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/python.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-Python版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/python-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/weixin.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-微信小程序版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/wx-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning m20 tc"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("如有其他技术问题，请扫描下方技术支持二维码添加技术对接工作人员进行咨询。")]), _vm._v(" "), _c('img', {
    staticClass: "tech-qrcode",
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "src": "/static/img/tech.jpg",
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu5 menu_tab"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab5-1"
    }
  }, [_c('div', {
    staticClass: "clearfix row help"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content2_he"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "panel"
    }
  }, [_c('div', {
    staticClass: "panel panel-default current"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        1、VIP开发者和普通开发者的区别\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("VIP开发者有更多的接口权限，更长的订单保存时间等功能。\n                                                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        2、设备单行打印多少个字符\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("众联云58mm系列云设备,一行打印16个汉字/32个字母\n                                                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        3、如何设置订单小票格式\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("参考开发文档,“打印任务”接口")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        4、二维码的大小是否可以调整\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("大小不能调整,根据内容的长度,动态生成")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        5、4G型号机器需要充值吗\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("要，机器从购买日起，送一年的4G流量费，过期后需要充值。\n                                                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        6、无线设备断网了，订单会漏吗\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                                                        不会漏单，由于网络异常情况导致设备离线，设备会不断的自动重连，订单是缓存在服务器上面的，机器重新联网后会继续打印之前未打印的订单。\n                                                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        7、打印任务的时候,刚好没纸了,会自动补打吗\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("会,重新装上纸后,会重新补打一份。")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        8、机器出现故障如何保修\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                                                        先电话或微信咨询客服，确认问题，非人为因素机器免费保修一年。人为因素要收取一定维修费用。维修统一寄回工厂处理。\n                                                                    ")])])])])])])])])])])
}]}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix npagePage product"
  }, [_c('div', {
    staticClass: "pde"
  }, [_c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_03.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_04.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_05.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_06.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_07.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_08.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_09.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_10.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_11.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_12.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/lyusb_13.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix npagePage product"
  }, [_c('div', {
    staticClass: "pde"
  }, [_c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_03.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_04.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_05.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_06.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_07.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_08.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_09.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_10.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_11.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_12.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_13.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_14.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_15.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_16.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/V58W_17.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix npagePage product"
  }, [_c('div', {
    staticClass: "pde"
  }, [_c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_03.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_04.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_05.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_06.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_07.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_08.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_09.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_10.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_11.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_12.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_13.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_14.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pimg wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/58Dimg_15.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container auto homePage2"
  }, [_vm._m(0), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "30px 150px"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('el-col', {
      key: item.title,
      attrs: {
        "span": 5
      }
    }, [_c('img', {
      attrs: {
        "src": '/static/img/a' + index + '.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p15"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.content))])])
  }), 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "header_title wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("SOLUTION")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "tit_cont"
  }, [_vm._v("\n                专注云打印解决方案，多年互联网应用开发经验，整合时下最新的云打印技术\n                "), _c('br'), _vm._v("以产品设计为核心驱动力，协同专业的项目能力，为客户提供针对性的解决方案，帮助客户解决问题\n            ")])])])
}]}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auto"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/one.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("多平台适用")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("DUO PING TAI SHI YONG")]), _vm._v(" "), _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "label-item"
  }, [_vm._v("1、匹配国内有美团、饿了么、京东到家等多平台同步开店的需求，连接多个平台只需一台打印机。")]), _vm._v(" "), _c('div', {
    staticClass: "label-item"
  }, [_vm._v("2、同时无需人工值守，避免人工操作导致的接单混乱等意外。")]), _vm._v(" "), _c('div', {
    staticClass: "label-item"
  }, [_vm._v("3、自主开放平台支持第三方平台接口对接，无平台接入数量限制。")])])])])
}]}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auto"
  }, [_c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("异地接单打印")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("YI DI JIE DAN DA YIN")]), _vm._v(" "), _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "label-item"
  }, [_vm._v("1、智慧云端，只要有电源有网络就可使用。")]), _vm._v(" "), _c('div', {
    staticClass: "label-item"
  }, [_vm._v("2、无需复杂配置，打印不受距离和场所限制。")]), _vm._v(" "), _c('div', {
    staticClass: "label-item"
  }, [_vm._v("3、云打印可使用在餐饮外卖以外领域，如鲜花、商超、医疗、零售等场景，匹配更广泛的市场需求。")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/cloud.png"
    }
  })])
}]}

/***/ })
],[226]);


// WEBPACK FOOTER //
// static/js/app.3405b16b6ca3bf3db0da.js